var _style, _path, _path2, _circle, _path3, _path4, _circle2, _path5, _path6, _path7, _path8, _path9, _ellipse, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path0, _path1, _path10, _path11, _path12, _path13, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _g, _text, _text2, _text3, _text4, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _path14, _path15, _circle91, _path16, _path17, _circle92, _path18, _path19, _circle93, _path20, _path21, _circle94, _path22, _path23, _circle95, _path24, _path25, _circle96, _path26, _path27, _circle97, _path28, _path29, _circle98, _path30, _path31, _circle99, _path32, _path33, _circle100, _path34, _path35, _circle101, _path36, _path37, _circle102, _path38, _path39, _circle103, _path40, _path41, _circle104, _path42, _path43, _circle105, _path44, _path45, _circle106, _path46, _path47, _circle107, _path48, _path49, _circle108, _path50, _path51, _circle109, _path52, _path53, _circle110, _path54, _path55, _circle111, _path56, _path57, _circle112, _path58, _path59, _circle113, _path60, _path61, _circle114, _path62, _path63, _circle115, _path64, _path65, _circle116, _path66, _path67, _circle117, _path68, _path69, _path70, _path71, _circle118, _path72, _path73, _circle119, _path74, _path75, _circle120, _path76, _path77, _circle121, _path78, _path79, _path80, _circle122, _path81, _path82, _circle123, _path83, _path84, _circle124, _text5, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _text6, _circle138, _circle139;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "250 50 350 250",
    style: {
      enableBackground: "new 0 0 792 612"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{fill:url(#SVGID_6_);}\n\t.st7{fill:url(#SVGID_7_);}\n\t.st8{fill:url(#SVGID_8_);}\n\t.st9{fill:url(#SVGID_9_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st10{fill:url(#SVGID_10_);}\n\t.st11{fill:url(#SVGID_11_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st12{fill:url(#SVGID_12_);}\n\t.st13{fill:url(#SVGID_13_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st14{fill:url(#SVGID_14_);}\n\t.st15{fill:url(#SVGID_15_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st16{fill:url(#SVGID_16_);}\n\t.st17{fill:url(#SVGID_17_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st18{fill:url(#SVGID_18_);}\n\t.st19{fill:url(#SVGID_19_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st20{fill:url(#SVGID_20_);}\n\t.st21{fill:url(#SVGID_21_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st22{fill:url(#SVGID_22_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st23{fill:url(#SVGID_23_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st24{fill:url(#SVGID_24_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st25{fill:url(#SVGID_25_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st26{fill:url(#SVGID_26_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st27{fill:url(#SVGID_27_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st28{fill:url(#SVGID_28_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st29{fill:url(#SVGID_29_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st30{fill:url(#SVGID_30_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st31{fill:url(#SVGID_31_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st32{fill:url(#SVGID_32_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st33{fill:url(#SVGID_33_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st34{fill:url(#SVGID_34_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st35{fill:url(#SVGID_35_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st36{fill:url(#SVGID_36_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st37{fill:url(#SVGID_37_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st38{fill:url(#SVGID_38_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st39{fill:url(#SVGID_39_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st40{fill:url(#SVGID_40_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st41{fill:url(#SVGID_41_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st42{fill:url(#SVGID_42_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st43{fill:url(#SVGID_43_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st44{fill:url(#SVGID_44_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st45{fill:url(#SVGID_45_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st46{fill:url(#SVGID_46_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st47{fill:url(#SVGID_47_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st48{fill:url(#SVGID_48_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st49{fill:url(#SVGID_49_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st50{fill:url(#SVGID_50_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st51{fill:url(#SVGID_51_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st52{fill:url(#SVGID_52_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st53{fill:url(#SVGID_53_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st54{fill:url(#SVGID_54_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st55{fill:url(#SVGID_55_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st56{fill:url(#SVGID_56_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st57{fill:url(#SVGID_57_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st58{fill:url(#SVGID_58_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st59{fill:url(#SVGID_59_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st60{fill:url(#SVGID_60_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st61{fill:url(#SVGID_61_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st62{fill:url(#SVGID_62_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st63{fill:url(#SVGID_63_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st64{fill:url(#SVGID_64_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st65{fill:url(#SVGID_65_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st66{fill:url(#SVGID_66_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st67{fill:url(#SVGID_67_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st68{fill:url(#SVGID_68_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st69{fill:url(#SVGID_69_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st70{fill:url(#SVGID_70_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st71{fill:url(#SVGID_71_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st72{fill:url(#SVGID_72_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st73{fill:url(#SVGID_73_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st74{fill:url(#SVGID_74_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st75{fill:url(#SVGID_75_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st76{fill:url(#SVGID_76_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st77{fill:url(#SVGID_77_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st78{fill:url(#SVGID_78_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st79{fill:url(#SVGID_79_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st80{fill:url(#SVGID_80_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st81{fill:url(#SVGID_81_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st82{fill:url(#SVGID_82_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st83{fill:url(#SVGID_83_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st84{fill:url(#SVGID_84_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st85{fill:url(#SVGID_85_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st86{fill:url(#SVGID_86_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st87{fill:url(#SVGID_87_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st88{fill:url(#SVGID_88_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st89{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st90{font-family: --apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\";}\n\t.st91{font-size:7px;}\n\t.st92{fill:url(#SVGID_89_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st93{fill:url(#SVGID_90_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st94{fill:url(#SVGID_91_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st95{fill:url(#SVGID_92_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st96{fill:url(#SVGID_93_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st97{fill:url(#SVGID_94_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st98{fill:url(#SVGID_95_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st99{fill:url(#SVGID_96_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st100{fill:url(#SVGID_97_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st101{fill:url(#SVGID_98_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st102{fill:url(#SVGID_99_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st103{fill:url(#SVGID_100_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st104{fill:url(#SVGID_101_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st105{fill:url(#SVGID_102_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st106{fill:url(#SVGID_103_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st107{fill:url(#SVGID_104_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st108{fill:url(#SVGID_105_);}\n\t.st109{fill:none;stroke:#000000;stroke-width:0.25;}\n\t.st110{fill:url(#SVGID_106_);}\n\t.st111{fill:url(#SVGID_107_);}\n\t.st112{fill:url(#SVGID_108_);}\n\t.st113{fill:url(#SVGID_109_);}\n\t.st114{fill:url(#SVGID_110_);}\n\t.st115{fill:url(#SVGID_111_);}\n\t.st116{fill:url(#SVGID_112_);}\n\t.st117{fill:url(#SVGID_113_);}\n\t.st118{fill:url(#SVGID_114_);}\n\t.st119{fill:url(#SVGID_115_);}\n\t.st120{fill:url(#SVGID_116_);}\n\t.st121{fill:url(#SVGID_117_);}\n\t.st122{fill:url(#SVGID_118_);}\n\t.st123{fill:url(#SVGID_119_);}\n\t.st124{fill:url(#SVGID_120_);}\n\t.st125{fill:url(#SVGID_121_);}\n\t.st126{fill:url(#SVGID_122_);}\n\t.st127{fill:url(#SVGID_123_);}\n\t.st128{fill:url(#SVGID_124_);}\n\t.st129{fill:url(#SVGID_125_);}\n\t.st130{fill:url(#SVGID_126_);}\n\t.st131{fill:url(#SVGID_127_);}\n\t.st132{fill:url(#SVGID_128_);}\n\t.st133{fill:url(#SVGID_129_);}\n\t.st134{fill:url(#SVGID_130_);}\n\t.st135{fill:url(#SVGID_131_);}\n\t.st136{fill:url(#SVGID_132_);}\n\t.st137{fill:url(#SVGID_133_);}\n\t.st138{fill:url(#SVGID_134_);}\n\t.st139{fill:url(#SVGID_135_);}\n\t.st140{fill:url(#SVGID_136_);}\n\t.st141{fill:url(#SVGID_137_);}\n\t.st142{fill:url(#SVGID_138_);}\n\t.st143{fill:url(#SVGID_139_);}\n\t.st144{fill:none;stroke:#131414;stroke-width:0.25;}\n\t.st145{fill:url(#SVGID_140_);}\n\t.st146{fill:url(#SVGID_141_);}\n\t.st147{fill:url(#SVGID_142_);}\n\t.st148{fill:url(#SVGID_143_);}\n\t.st149{fill:url(#SVGID_144_);}\n\t.st150{fill:url(#SVGID_145_);}\n\t.st151{fill:url(#SVGID_146_);}\n\t.st152{fill:url(#SVGID_147_);}\n\t.st153{fill:url(#SVGID_148_);}\n\t.st154{fill:url(#SVGID_149_);}\n\t.st155{fill:url(#SVGID_150_);}\n\t.st156{fill:url(#SVGID_151_);}\n\t.st157{fill:url(#SVGID_152_);}\n\t.st158{fill:url(#SVGID_153_);}\n\t.st159{fill:url(#SVGID_154_);}\n\t.st160{fill:url(#SVGID_155_);}\n\t.st161{fill:url(#SVGID_156_);}\n\t.st162{fill:url(#SVGID_157_);}\n\t.st163{fill:url(#SVGID_158_);}\n\t.st164{fill:none;stroke:url(#SVGID_159_);stroke-width:4;stroke-miterlimit:10;}\n\t.st165{fill:none;stroke:url(#SVGID_160_);stroke-width:4;stroke-miterlimit:10;}\n\t.st166{fill:url(#SVGID_161_);}\n\t.st167{fill:url(#SVGID_162_);}\n\t.st168{fill:url(#SVGID_163_);}\n\t.st169{fill:url(#SVGID_164_);}\n\t.st170{fill:url(#SVGID_165_);}\n\t.st171{fill:url(#SVGID_166_);}\n\t.st172{fill:url(#SVGID_167_);}\n\t.st173{fill:url(#SVGID_168_);}\n\t.st174{fill:none;stroke:url(#SVGID_169_);stroke-width:4;stroke-miterlimit:10;}\n\t.st175{fill:url(#SVGID_170_);}\n\t.st176{fill:url(#SVGID_171_);}\n\t.st177{fill:url(#SVGID_172_);}\n\t.st178{fill:url(#SVGID_173_);}\n\t.st179{fill:url(#SVGID_174_);}\n\t.st180{fill:url(#SVGID_175_);}\n\t.st181{fill:url(#SVGID_176_);stroke:#000000;stroke-width:0.25;}\n\t.st182{fill:url(#SVGID_177_);}\n\t.st183{fill:url(#SVGID_178_);stroke:#000000;stroke-width:0.25;}\n\t.st184{fill:url(#SVGID_179_);}\n\t.st185{fill:url(#SVGID_180_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st186{fill:url(#SVGID_181_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st187{fill:url(#SVGID_182_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st188{fill:url(#SVGID_183_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st189{fill:url(#SVGID_184_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st190{fill:url(#SVGID_185_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st191{fill:url(#SVGID_186_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st192{fill:url(#SVGID_187_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st193{fill:url(#SVGID_188_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st194{fill:url(#SVGID_189_);stroke:#000000;stroke-width:0.25;}\n\t.st195{fill:url(#SVGID_190_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 469.2457,
    cy: 184.0274,
    r: 19.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    style: {
      stopColor: "#F7EFF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    style: {
      stopColor: "#EAD0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D9A4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D9A4C4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M457.61,178.28c0.98-0.28,1.78-1.83,1.78-3.44c0-1.61-0.8-4.05-1.78-5.43s-0.98-2.79,0-3.15 c0.98-0.36,2.81-0.3,4.06,0.14c1.25,0.43,3.4,1.43,4.77,2.22s3.25,0.69,4.19-0.22c0.93-0.91,2.46-2.11,3.39-2.67 c0.93-0.56,2.22-0.81,2.86-0.56s1.17,1.38,1.17,2.51c0,1.13,0.52,2.81,1.16,3.72c0.64,0.92,2.07,2.04,3.18,2.5 c1.11,0.45,2.83,1.07,3.82,1.36c0.99,0.29,2.14,1.21,2.54,2.04s-0.31,2.31-1.59,3.3s-2.62,2.71-2.97,3.84s-0.59,3.02-0.53,4.2 c0.06,1.18,0.15,2.97,0.21,3.97c0.06,1-0.32,2.36-0.85,3.03c-0.52,0.67-1.34,1.5-1.81,1.85s-1.66,0.64-2.65,0.64 s-2.72-0.49-3.85-1.1c-1.13-0.6-2.51-1.19-3.07-1.3s-1.49,0.38-2.08,1.1c-0.58,0.72-1.16,1.76-1.27,2.31 c-0.12,0.56-0.55,1.32-0.95,1.7c-0.41,0.38-1.66,1.02-2.79,1.43c-1.13,0.41-3.03,0.74-4.24,0.74s-2.05-0.64-1.88-1.43 s0.84-2.17,1.48-3.07c0.64-0.91,1.07-2.5,0.95-3.55c-0.12-1.05-1.07-2.39-2.12-2.98c-1.05-0.59-2.9-1.08-4.12-1.08 s-2.69-0.81-3.29-1.8c-0.59-0.99-1.33-2.45-1.64-3.24c-0.31-0.79,0.17-1.44,1.08-1.44s1.64-0.73,1.64-1.61s-0.29-2.14-0.65-2.8 c-0.36-0.65,0.4-1.18,1.7-1.18S456.63,178.57,457.61,178.28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M457.61,178.28c0.98-0.28,1.78-1.83,1.78-3.44c0-1.61-0.8-4.05-1.78-5.43s-0.98-2.79,0-3.15 c0.98-0.36,2.81-0.3,4.06,0.14c1.25,0.43,3.4,1.43,4.77,2.22s3.25,0.69,4.19-0.22c0.93-0.91,2.46-2.11,3.39-2.67 c0.93-0.56,2.22-0.81,2.86-0.56s1.17,1.38,1.17,2.51c0,1.13,0.52,2.81,1.16,3.72c0.64,0.92,2.07,2.04,3.18,2.5 c1.11,0.45,2.83,1.07,3.82,1.36c0.99,0.29,2.14,1.21,2.54,2.04s-0.31,2.31-1.59,3.3s-2.62,2.71-2.97,3.84s-0.59,3.02-0.53,4.2 c0.06,1.18,0.15,2.97,0.21,3.97c0.06,1-0.32,2.36-0.85,3.03c-0.52,0.67-1.34,1.5-1.81,1.85s-1.66,0.64-2.65,0.64 s-2.72-0.49-3.85-1.1c-1.13-0.6-2.51-1.19-3.07-1.3s-1.49,0.38-2.08,1.1c-0.58,0.72-1.16,1.76-1.27,2.31 c-0.12,0.56-0.55,1.32-0.95,1.7c-0.41,0.38-1.66,1.02-2.79,1.43c-1.13,0.41-3.03,0.74-4.24,0.74s-2.05-0.64-1.88-1.43 s0.84-2.17,1.48-3.07c0.64-0.91,1.07-2.5,0.95-3.55c-0.12-1.05-1.07-2.39-2.12-2.98c-1.05-0.59-2.9-1.08-4.12-1.08 s-2.69-0.81-3.29-1.8c-0.59-0.99-1.33-2.45-1.64-3.24c-0.31-0.79,0.17-1.44,1.08-1.44s1.64-0.73,1.64-1.61s-0.29-2.14-0.65-2.8 c-0.36-0.65,0.4-1.18,1.7-1.18S456.63,178.57,457.61,178.28z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 469.3242,
    cy: 182.8168,
    r: 7.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 469.32,
    cy: 182.82,
    r: 7.42
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 452.356,
    cy: 285.9765,
    r: 20.3439,
    gradientTransform: "matrix(0.7797 0.6262 -0.6262 0.7797 335.8706 -327.3441)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    style: {
      stopColor: "#F7EFF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    style: {
      stopColor: "#EAD0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D9A4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D9A4C4"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M500,168.26c1.73-0.07,3.78-1.64,4.54-3.48c0.76-1.84,1.34-4.21,1.29-5.27s0.71-1.28,1.7-0.49 s2.14,2.21,2.58,3.16c0.44,0.95,1.24,2.14,1.8,2.64c0.55,0.5,1.98,1.16,3.18,1.46c1.19,0.3,2.53,0.4,2.98,0.22 c0.44-0.18,1.71-0.42,2.81-0.52s2.82-0.24,3.83-0.3c1-0.06,2.14,0.54,2.53,1.33c0.38,0.79,0.15,1.69-0.53,2.01 c-0.67,0.32-1.68,1.08-2.23,1.69s-1.1,1.72-1.22,2.46s0.42,1.96,1.2,2.7c0.78,0.74,1.86,1.71,2.41,2.15 c0.55,0.44,1.44,1.16,1.98,1.59c0.55,0.44,1.18,1.24,1.4,1.78c0.22,0.54-0.21,1.32-0.96,1.73c-0.75,0.41-1.88,1.27-2.51,1.9 s-1.47,1.62-1.87,2.2c-0.4,0.57-1.05,1.57-1.45,2.21s-0.97,1.84-1.28,2.67c-0.31,0.83-0.61,2.1-0.67,2.83 c-0.06,0.73-0.52,1.83-1.02,2.45s-1.78,1.01-2.84,0.87s-2.53-0.43-3.25-0.65s-2.05-1-2.96-1.73c-0.91-0.73-2.05-1.94-2.52-2.68 c-0.48-0.74-1.61-1.41-2.52-1.48c-0.91-0.07-2.66,0.04-3.89,0.24c-1.23,0.21-3.85,1.53-5.82,2.94c0,0,0,0-0.53-0.42 c-0.53-0.42-0.53-0.42-0.53-0.42c-0.57-1.53-1.02-3.46-1.01-4.29s0.08-2.63,0.17-4s0.06-3.1-0.06-3.85s-0.95-2.15-1.85-3.12 c-0.9-0.96-2.03-2.31-2.5-2.98c-0.47-0.68-0.8-1.97-0.74-2.88s0.39-1.97,0.71-2.37c0.32-0.4,1.24-0.2,2.04,0.44 s1.91,1.58,2.46,2.08s1.4,1.04,1.88,1.18c0.48,0.15,0.82-0.71,0.76-1.89c-0.06-1.19-0.23-2.57-0.37-3.07 C496.96,168.8,498.27,168.33,500,168.26z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M500,168.26c1.73-0.07,3.78-1.64,4.54-3.48c0.76-1.84,1.34-4.21,1.29-5.27s0.71-1.28,1.7-0.49 s2.14,2.21,2.58,3.16c0.44,0.95,1.24,2.14,1.8,2.64c0.55,0.5,1.98,1.16,3.18,1.46c1.19,0.3,2.53,0.4,2.98,0.22 c0.44-0.18,1.71-0.42,2.81-0.52s2.82-0.24,3.83-0.3c1-0.06,2.14,0.54,2.53,1.33c0.38,0.79,0.15,1.69-0.53,2.01 c-0.67,0.32-1.68,1.08-2.23,1.69s-1.1,1.72-1.22,2.46s0.42,1.96,1.2,2.7c0.78,0.74,1.86,1.71,2.41,2.15 c0.55,0.44,1.44,1.16,1.98,1.59c0.55,0.44,1.18,1.24,1.4,1.78c0.22,0.54-0.21,1.32-0.96,1.73c-0.75,0.41-1.88,1.27-2.51,1.9 s-1.47,1.62-1.87,2.2c-0.4,0.57-1.05,1.57-1.45,2.21s-0.97,1.84-1.28,2.67c-0.31,0.83-0.61,2.1-0.67,2.83 c-0.06,0.73-0.52,1.83-1.02,2.45s-1.78,1.01-2.84,0.87s-2.53-0.43-3.25-0.65s-2.05-1-2.96-1.73c-0.91-0.73-2.05-1.94-2.52-2.68 c-0.48-0.74-1.61-1.41-2.52-1.48c-0.91-0.07-2.66,0.04-3.89,0.24c-1.23,0.21-3.85,1.53-5.82,2.94c0,0,0,0-0.53-0.42 c-0.53-0.42-0.53-0.42-0.53-0.42c-0.57-1.53-1.02-3.46-1.01-4.29s0.08-2.63,0.17-4s0.06-3.1-0.06-3.85s-0.95-2.15-1.85-3.12 c-0.9-0.96-2.03-2.31-2.5-2.98c-0.47-0.68-0.8-1.97-0.74-2.88s0.39-1.97,0.71-2.37c0.32-0.4,1.24-0.2,2.04,0.44 s1.91,1.58,2.46,2.08s1.4,1.04,1.88,1.18c0.48,0.15,0.82-0.71,0.76-1.89c-0.06-1.19-0.23-2.57-0.37-3.07 C496.96,168.8,498.27,168.33,500,168.26z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 452.356,
    cy: 285.7243,
    r: 7.423,
    gradientTransform: "matrix(0.7797 0.6262 -0.6262 0.7797 335.8706 -327.3441)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 509.66,
    cy: 178.68,
    r: 7.42
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 481.0769,
    cy: 236.4097,
    r: 21.9071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#887EB3"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M504.28,220.94c1.91-2.97,0.71-4.66-2.66-3.74c-3.37,0.91-8.43,2.84-11.23,4.29 c-2.8,1.45-7.3,4.28-9.99,6.31c-2.69,2.02-6.76,5.61-9.03,7.98c-2.27,2.37-5.96,6.53-8.19,9.26c-2.23,2.73-4.85,6.55-5.82,8.5 s0.02,2.86,2.21,2.03s6.58-2.71,9.77-4.17c3.18-1.46,7.71-4.1,10.05-5.86c2.35-1.76,6.77-5.08,9.82-7.38 c3.06-2.3,6.92-5.89,8.58-7.99S502.37,223.92,504.28,220.94z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M504.28,220.94c1.91-2.97,0.71-4.66-2.66-3.74c-3.37,0.91-8.43,2.84-11.23,4.29 c-2.8,1.45-7.3,4.28-9.99,6.31c-2.69,2.02-6.76,5.61-9.03,7.98c-2.27,2.37-5.96,6.53-8.19,9.26c-2.23,2.73-4.85,6.55-5.82,8.5 s0.02,2.86,2.21,2.03s6.58-2.71,9.77-4.17c3.18-1.46,7.71-4.1,10.05-5.86c2.35-1.76,6.77-5.08,9.82-7.38 c3.06-2.3,6.92-5.89,8.58-7.99S502.37,223.92,504.28,220.94z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 348.4426,
    cy: 289.9199,
    r: 6.1654,
    gradientTransform: "matrix(0.6011 0.7992 -0.7992 0.6011 502.6024 -216.4306)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#887EB3"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M482.35,238.96c-3.56,2.68-7.34,3.65-8.44,2.19s0.88-4.83,4.44-7.5c3.56-2.68,7.34-3.65,8.44-2.19 C487.9,232.93,485.91,236.29,482.35,238.96z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 477.3017,
    cy: 231.3502,
    r: 25.4082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#887EB3"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M445.05,234.61c1.32-0.66,5.63-1.47,9.58-1.79c3.95-0.32,12.11-0.32,18.14,0 c6.03,0.32,14.98,2.34,19.91,4.48c4.92,2.14,11.34,5.64,14.25,7.77c2.92,2.14,4.03,0.49,2.47-3.65 c-1.55-4.15-6.17-10.35-10.25-13.78s-9.81-7.3-12.72-8.6c-2.92-1.3-8.75-2.36-12.96-2.36c-4.21,0-10.68,2.07-14.37,4.59 c-3.69,2.53-8.9,6.83-11.58,9.56S443.73,235.28,445.05,234.61z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M445.05,234.61c1.32-0.66,5.63-1.47,9.58-1.79c3.95-0.32,12.11-0.32,18.14,0 c6.03,0.32,14.98,2.34,19.91,4.48c4.92,2.14,11.34,5.64,14.25,7.77c2.92,2.14,4.03,0.49,2.47-3.65 c-1.55-4.15-6.17-10.35-10.25-13.78s-9.81-7.3-12.72-8.6c-2.92-1.3-8.75-2.36-12.96-2.36c-4.21,0-10.68,2.07-14.37,4.59 c-3.69,2.53-8.9,6.83-11.58,9.56S443.73,235.28,445.05,234.61z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 417.9286,
    cy: 445.0701,
    r: 6.1654,
    gradientTransform: "matrix(-1.480000e-13 1 -1 -1.480000e-13 921.8943 -192.2585)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#887EB3"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 476.82,
    cy: 225.67,
    rx: 8.06,
    ry: 3.33
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 418.4078,
    cy: 96.3794,
    r: 11.1313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1866,
    style: {
      stopColor: "#FAF6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3905,
    style: {
      stopColor: "#EEE4E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6087,
    style: {
      stopColor: "#E1CCD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8355,
    style: {
      stopColor: "#D0AEB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#C396A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C396A0"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 418.41,
    cy: 96.38,
    r: 11.13
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 420.5133,
    cy: 96.5236,
    r: 7.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E3D0D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0505,
    style: {
      stopColor: "#DAC1C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    style: {
      stopColor: "#C69BA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3543,
    style: {
      stopColor: "#B77F8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5096,
    style: {
      stopColor: "#AC6C7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6673,
    style: {
      stopColor: "#A55E73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8288,
    style: {
      stopColor: "#A1566D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9F536B"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 420.51,
    cy: 96.52,
    r: 7.42
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 430.047,
    cy: 73.0567,
    r: 11.1313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1866,
    style: {
      stopColor: "#FAF6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3905,
    style: {
      stopColor: "#EEE4E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6087,
    style: {
      stopColor: "#E1CCD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8355,
    style: {
      stopColor: "#D0AEB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#C396A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C396A0"
    }
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 430.05,
    cy: 73.06,
    r: 11.13
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 432.1525,
    cy: 73.2009,
    r: 7.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E3D0D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0505,
    style: {
      stopColor: "#DAC1C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    style: {
      stopColor: "#C69BA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3543,
    style: {
      stopColor: "#B77F8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5096,
    style: {
      stopColor: "#AC6C7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6673,
    style: {
      stopColor: "#A55E73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8288,
    style: {
      stopColor: "#A1566D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9F536B"
    }
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 432.15,
    cy: 73.2,
    r: 7.42
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 443.5789,
    cy: 95.4043,
    r: 11.1313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1866,
    style: {
      stopColor: "#FAF6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3905,
    style: {
      stopColor: "#EEE4E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6087,
    style: {
      stopColor: "#E1CCD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8355,
    style: {
      stopColor: "#D0AEB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#C396A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C396A0"
    }
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 443.58,
    cy: 95.4,
    r: 11.13
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 445.6844,
    cy: 95.5485,
    r: 7.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E3D0D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0505,
    style: {
      stopColor: "#DAC1C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2007,
    style: {
      stopColor: "#C69BA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3543,
    style: {
      stopColor: "#B77F8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5096,
    style: {
      stopColor: "#AC6C7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6673,
    style: {
      stopColor: "#A55E73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8288,
    style: {
      stopColor: "#A1566D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9F536B"
    }
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 445.68,
    cy: 95.55,
    r: 7.42
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 440.8956,
    cy: 278.868,
    r: 13.3958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2575,
    style: {
      stopColor: "#FCEBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7526,
    style: {
      stopColor: "#F8CEAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F6C498"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6C498"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M447.42,289.33h-13.04c-5.1,0-9.28-4.17-9.28-9.28v-2.37c0-5.1,4.17-9.28,9.28-9.28h13.04 c5.1,0,9.28,4.17,9.28,9.28v2.37C456.69,285.15,452.52,289.33,447.42,289.33z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: 438.9182,
    cy: 280.7784,
    r: 6.4436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBE6D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1109,
    style: {
      stopColor: "#FADBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    style: {
      stopColor: "#F3B581"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8453,
    style: {
      stopColor: "#EF9F5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED9750"
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M442.33,285.34h-6.82c-2.46,0-4.48-2.01-4.48-4.48v-0.17c0-2.46,2.01-4.48,4.48-4.48h6.82 c2.46,0,4.48,2.01,4.48,4.48v0.17C446.81,283.33,444.79,285.34,442.33,285.34z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_17_",
    cx: 423.2581,
    cy: 263.8004,
    r: 13.3958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2575,
    style: {
      stopColor: "#FCEBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7526,
    style: {
      stopColor: "#F8CEAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F6C498"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6C498"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M429.78,274.26h-13.04c-5.1,0-9.28-4.17-9.28-9.28v-2.37c0-5.1,4.17-9.28,9.28-9.28h13.04 c5.1,0,9.28,4.17,9.28,9.28v2.37C439.05,270.08,434.88,274.26,429.78,274.26z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: 421.2806,
    cy: 265.7108,
    r: 6.4436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBE6D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1109,
    style: {
      stopColor: "#FADBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    style: {
      stopColor: "#F3B581"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8453,
    style: {
      stopColor: "#EF9F5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED9750"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M424.69,270.27h-6.82c-2.46,0-4.48-2.01-4.48-4.48v-0.17c0-2.46,2.01-4.48,4.48-4.48h6.82 c2.46,0,4.48,2.01,4.48,4.48v0.17C429.17,268.26,427.15,270.27,424.69,270.27z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: 410.4525,
    cy: 281.8152,
    r: 13.3958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2575,
    style: {
      stopColor: "#FCEBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7526,
    style: {
      stopColor: "#F8CEAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#F6C498"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6C498"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M416.97,292.27h-13.04c-5.1,0-9.28-4.17-9.28-9.28v-2.37c0-5.1,4.17-9.28,9.28-9.28h13.04 c5.1,0,9.28,4.17,9.28,9.28V283C426.25,288.1,422.07,292.27,416.97,292.27z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: 408.475,
    cy: 283.7256,
    r: 6.4436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBE6D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1109,
    style: {
      stopColor: "#FADBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    style: {
      stopColor: "#F3B581"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8453,
    style: {
      stopColor: "#EF9F5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED9750"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M411.89,288.29h-6.82c-2.46,0-4.48-2.01-4.48-4.48v-0.17c0-2.46,2.01-4.48,4.48-4.48h6.82 c2.46,0,4.48,2.01,4.48,4.48v0.17C416.36,286.27,414.35,288.29,411.89,288.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_21_",
    cx: 408.8927,
    cy: 196.6879,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 408.89,
    cy: 196.69,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_22_",
    cx: 417.9077,
    cy: 181.4851,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 417.91,
    cy: 181.49,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_23_",
    cx: 407.8635,
    cy: 176.0305,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "st23",
    cx: 407.86,
    cy: 176.03,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_24_",
    cx: 408.5613,
    cy: 190.0752,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st24",
    cx: 408.56,
    cy: 190.08,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_25_",
    cx: 405.1386,
    cy: 183.5863,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 405.14,
    cy: 183.59,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_26_",
    cx: 439.4921,
    cy: 180.2923,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 439.49,
    cy: 180.29,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_27_",
    cx: 424.7669,
    cy: 175.2278,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 424.77,
    cy: 175.23,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_28_",
    cx: 425.4646,
    cy: 189.2726,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st28",
    cx: 425.46,
    cy: 189.27,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_29_",
    cx: 415.014,
    cy: 188.0574,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st29",
    cx: 415.01,
    cy: 188.06,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_30_",
    cx: 400.2864,
    cy: 193.8196,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st30",
    cx: 400.29,
    cy: 193.82,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_31_",
    cx: 396.8637,
    cy: 187.3306,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 396.86,
    cy: 187.33,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_32_",
    cx: 394.1388,
    cy: 194.8864,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 394.14,
    cy: 194.89,
    r: 2.55
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_33_",
    cx: 421.4734,
    cy: 108.2143,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "st33",
    cx: 399.83,
    cy: 132.58,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_34_",
    cx: 414.8219,
    cy: 99.0723,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "st34",
    cx: 390.54,
    cy: 126.14,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_35_",
    cx: 411.8232,
    cy: 107.5518,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "st35",
    cx: 390.5,
    cy: 135.13,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_36_",
    cx: 405.2845,
    cy: 106.9086,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "st36",
    cx: 384.11,
    cy: 136.68,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_37_",
    cx: 444.6605,
    cy: 96.9915,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "st37",
    cx: 418.03,
    cy: 114.35,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_38_",
    cx: 419.2465,
    cy: 128.3128,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "st38",
    cx: 404.34,
    cy: 152.29,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_39_",
    cx: 420.3575,
    cy: 94.6624,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "st39",
    cx: 394.31,
    cy: 120.15,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_40_",
    cx: 465.1887,
    cy: 103.3126,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 439.49,
    cy: 113.56,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_41_",
    cx: 438.998,
    cy: 125.3933,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    className: "st41",
    cx: 422.03,
    cy: 143.03,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_42_",
    cx: 449.6895,
    cy: 115.3506,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    className: "st42",
    cx: 428.82,
    cy: 130.03,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_43_",
    cx: 427.1857,
    cy: 126.4023,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    className: "st43",
    cx: 411.21,
    cy: 147.87,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_44_",
    cx: 439.9385,
    cy: 110.5331,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    className: "st44",
    cx: 418.03,
    cy: 128.69,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_45_",
    cx: 457.8757,
    cy: 110.3379,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    className: "st45",
    cx: 434.9,
    cy: 122.6,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_46_",
    cx: 430.5077,
    cy: 91.6187,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    className: "st46",
    cx: 402.89,
    cy: 113.93,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_47_",
    cx: 426.5787,
    cy: 102.1272,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    className: "st47",
    cx: 402.64,
    cy: 125.15,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_48_",
    cx: 410.5222,
    cy: 91.2328,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    className: "st48",
    cx: 383.9,
    cy: 120.15,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_49_",
    cx: 442.637,
    cy: 119.9335,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    className: "st49",
    cx: 423.67,
    cy: 136.68,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_50_",
    cx: 446.5274,
    cy: 106.0969,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    className: "st50",
    cx: 422.79,
    cy: 122.33,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_51_",
    cx: 431.9168,
    cy: 116.1953,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    className: "st51",
    cx: 412.32,
    cy: 136.68,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_52_",
    cx: 435.782,
    cy: 101.2211,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    className: "st52",
    cx: 411.04,
    cy: 121.26,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_53_",
    cx: 423.156,
    cy: 117.101,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    className: "st53",
    cx: 404.34,
    cy: 140.42,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_54_",
    cx: 455.8333,
    cy: 101.779,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    className: "st54",
    cx: 430.15,
    cy: 115.19,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_55_",
    cx: 437.5527,
    cy: 91.8104,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    className: "st55",
    cx: 409.61,
    cy: 111.79,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_56_",
    cx: 413.0702,
    cy: 117.0704,
    r: 2.5512,
    gradientTransform: "matrix(0.9442 -0.3293 0.3293 0.9442 -33.7742 169.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    className: "st56",
    cx: 394.81,
    cy: 143.71,
    r: 2.55
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_57_",
    cx: 390.2493,
    cy: 252.2422,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    className: "st57",
    cx: 390.25,
    cy: 252.24,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_58_",
    cx: 372.1298,
    cy: 249.691,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    className: "st58",
    cx: 372.13,
    cy: 249.69,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_59_",
    cx: 360.6409,
    cy: 241.4081,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    className: "st59",
    cx: 360.64,
    cy: 241.41,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_60_",
    cx: 372.7968,
    cy: 265.5602,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 372.8,
    cy: 265.56,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_61_",
    cx: 365.5276,
    cy: 253.3416,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    className: "st61",
    cx: 365.53,
    cy: 253.34,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_62_",
    cx: 385.3971,
    cy: 262.4756,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    className: "st62",
    cx: 385.4,
    cy: 262.48,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_63_",
    cx: 375.5217,
    cy: 256.4481,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    className: "st63",
    cx: 375.52,
    cy: 256.45,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_64_",
    cx: 382.6722,
    cy: 270.0313,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    className: "st64",
    cx: 382.67,
    cy: 270.03,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_65_",
    cx: 379.2495,
    cy: 263.5424,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    className: "st65",
    cx: 379.25,
    cy: 263.54,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_66_",
    cx: 381.8008,
    cy: 235.0799,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    className: "st66",
    cx: 381.8,
    cy: 235.08,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_67_",
    cx: 375.5217,
    cy: 229.8649,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    className: "st67",
    cx: 375.52,
    cy: 229.86,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_68_",
    cx: 370.5667,
    cy: 238.8569,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    className: "st68",
    cx: 370.57,
    cy: 238.86,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_69_",
    cx: 381.9744,
    cy: 248.3808,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    className: "st69",
    cx: 381.97,
    cy: 248.38,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_70_",
    cx: 390.1688,
    cy: 270.194,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    className: "st70",
    cx: 390.17,
    cy: 270.19,
    r: 2.55
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_71_",
    cx: 337.5947,
    cy: 229.4925,
    r: 2.5512,
    gradientTransform: "matrix(0.9696 0.2445 -0.2445 0.9696 114.5096 -75.7033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    className: "st71",
    cx: 385.74,
    cy: 229.37,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_72_",
    cx: 358.2962,
    cy: 206.147,
    r: 2.5512,
    gradientTransform: "matrix(0.9696 0.2445 -0.2445 0.9696 114.5096 -75.7033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    className: "st72",
    cx: 411.53,
    cy: 211.79,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_73_",
    cx: 368.1716,
    cy: 210.6181,
    r: 2.5512,
    gradientTransform: "matrix(0.9696 0.2445 -0.2445 0.9696 114.5096 -75.7033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    className: "st73",
    cx: 420.01,
    cy: 218.54,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_74_",
    cx: 340.1459,
    cy: 205.4202,
    r: 2.5512,
    gradientTransform: "matrix(0.9696 0.2445 -0.2445 0.9696 114.5096 -75.7033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    className: "st74",
    cx: 394.1,
    cy: 206.65,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_75_",
    cx: 350.0213,
    cy: 209.8913,
    r: 2.5512,
    gradientTransform: "matrix(0.9696 0.2445 -0.2445 0.9696 114.5096 -75.7033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    className: "st75",
    cx: 402.59,
    cy: 213.4,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_76_",
    cx: 342.6971,
    cy: 217.8031,
    r: 2.5512,
    gradientTransform: "matrix(0.9696 0.2445 -0.2445 0.9696 114.5096 -75.7033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    className: "st76",
    cx: 393.55,
    cy: 219.28,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_77_",
    cx: 343.8738,
    cy: 210.9582,
    r: 2.5512,
    gradientTransform: "matrix(0.9696 0.2445 -0.2445 0.9696 114.5096 -75.7033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    className: "st77",
    cx: 396.36,
    cy: 212.93,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_78_",
    cx: 379.0909,
    cy: 217.2697,
    r: 2.5512,
    gradientTransform: "matrix(0.9696 0.2445 -0.2445 0.9696 114.5096 -75.7033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    className: "st78",
    cx: 428.97,
    cy: 227.66,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_79_",
    cx: 391.6912,
    cy: 214.1851,
    r: 2.5512,
    gradientTransform: "matrix(0.9696 0.2445 -0.2445 0.9696 114.5096 -75.7033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    className: "st79",
    cx: 441.94,
    cy: 227.75,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_80_",
    cx: 388.9663,
    cy: 221.7409,
    r: 2.5512,
    gradientTransform: "matrix(0.9696 0.2445 -0.2445 0.9696 114.5096 -75.7033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    className: "st80",
    cx: 437.45,
    cy: 234.41,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_81_",
    cx: 385.5436,
    cy: 215.2519,
    r: 2.5512,
    gradientTransform: "matrix(0.9696 0.2445 -0.2445 0.9696 114.5096 -75.7033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    className: "st81",
    cx: 435.72,
    cy: 227.28,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_82_",
    cx: 360.9406,
    cy: 216.5429,
    r: 2.5512,
    gradientTransform: "matrix(0.9696 0.2445 -0.2445 0.9696 114.5096 -75.7033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    className: "st82",
    cx: 411.55,
    cy: 222.52,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_83_",
    cx: 358.2157,
    cy: 224.0987,
    r: 2.5512,
    gradientTransform: "matrix(0.9696 0.2445 -0.2445 0.9696 114.5096 -75.7033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    className: "st83",
    cx: 407.06,
    cy: 229.18,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_84_",
    cx: 354.793,
    cy: 217.6098,
    r: 2.5512,
    gradientTransform: "matrix(0.9696 0.2445 -0.2445 0.9696 114.5096 -75.7033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    className: "st84",
    cx: 405.33,
    cy: 222.05,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_85_",
    cx: 370.816,
    cy: 221.0141,
    r: 2.5512,
    gradientTransform: "matrix(0.9696 0.2445 -0.2445 0.9696 114.5096 -75.7033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    className: "st85",
    cx: 420.03,
    cy: 229.27,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_86_",
    cx: 347.9789,
    cy: 225.7091,
    r: 2.5512,
    gradientTransform: "matrix(0.9696 0.2445 -0.2445 0.9696 114.5096 -75.7033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    className: "st86",
    cx: 396.74,
    cy: 228.24,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_87_",
    cx: 368.0911,
    cy: 228.5699,
    r: 2.5512,
    gradientTransform: "matrix(0.9696 0.2445 -0.2445 0.9696 114.5096 -75.7033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    className: "st87",
    cx: 415.54,
    cy: 235.93,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_88_",
    cx: 364.6685,
    cy: 222.0809,
    r: 2.5512,
    gradientTransform: "matrix(0.9696 0.2445 -0.2445 0.9696 114.5096 -75.7033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    className: "st88",
    cx: 413.81,
    cy: 228.8,
    r: 2.55
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M342.12,235.18c1.13-0.12,6.41-0.59,9.72,3.14c4.39,4.94,2.23,13.77-1.33,18.79 c-3.6,5.08-10.24,8.54-16.65,6.66c-0.71-0.21-8.38-2.61-9.89-10.7c-0.74-3.97,0.36-7.42,1.61-9.85"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "326.83,246.56 325.15,244.05 322.18,243.52 328.1,239.53  "
  }))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 451.8156 80.6239)",
    className: "st90 st91"
  }, "T cells")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 535.2086 181.7026)",
    className: "st90 st91"
  }, "TAMs")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 512.2306 232.8249)",
    className: "st90 st91"
  }, "CAFs")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 464.1981 280.7783)",
    className: "st90 st91"
  }, "TECs")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_89_",
    cx: 346.6141,
    cy: 252.2422,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    className: "st92",
    cx: 346.61,
    cy: 252.24,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_90_",
    cx: 317.9918,
    cy: 250.7904,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    className: "st93",
    cx: 317.99,
    cy: 250.79,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_91_",
    cx: 332.3044,
    cy: 269.8104,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    className: "st94",
    cx: 332.3,
    cy: 269.81,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_92_",
    cx: 317.9918,
    cy: 259.9243,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    className: "st95",
    cx: 317.99,
    cy: 259.92,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_93_",
    cx: 357.7516,
    cy: 252.2422,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    className: "st96",
    cx: 357.75,
    cy: 252.24,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_94_",
    cx: 345.8675,
    cy: 266.4824,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 345.87,
    cy: 266.48,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_95_",
    cx: 353.0599,
    cy: 267.2592,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    className: "st98",
    cx: 353.06,
    cy: 267.26,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_96_",
    cx: 340.574,
    cy: 272.7452,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    className: "st99",
    cx: 340.57,
    cy: 272.75,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_97_",
    cx: 348.9041,
    cy: 276.3168,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    className: "st100",
    cx: 348.9,
    cy: 276.32,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_98_",
    cx: 334.8556,
    cy: 277.8819,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    className: "st101",
    cx: 334.86,
    cy: 277.88,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_99_",
    cx: 328.2991,
    cy: 253.3416,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    className: "st102",
    cx: 328.3,
    cy: 253.34,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_100_",
    cx: 359.214,
    cy: 260.9912,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    className: "st103",
    cx: 359.21,
    cy: 260.99,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_101_",
    cx: 320.1222,
    cy: 270.194,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 320.12,
    cy: 270.19,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_102_",
    cx: 325.4363,
    cy: 264.29,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    className: "st105",
    cx: 325.44,
    cy: 264.29,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_103_",
    cx: 327.2019,
    cy: 277.0974,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 327.2,
    cy: 277.1,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_104_",
    cx: 332.3044,
    cy: 244.5886,
    r: 2.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46AFC4"
    }
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    className: "st107",
    cx: 332.3,
    cy: 244.59,
    r: 2.55
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_105_",
    cx: 93.6286,
    cy: 185.8698,
    r: 15.2571,
    gradientTransform: "matrix(-0.3422 0.8387 -0.9259 -0.3778 563.2015 143.0348)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFF0F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    style: {
      stopColor: "#D5ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    style: {
      stopColor: "#BDE0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A6D6E3"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M369.82,140.15c-0.1,0.78,0.06,2.28,0.36,3.32c0.29,1.04,0.61,2.79,0.7,3.88 c0.09,1.09-1.13,2.65-2.71,3.46c-1.58,0.81-4.05,2.82-5.49,4.47s-3.28,4.65-4.1,6.67c-0.82,2.02-2.42,4.15-3.56,4.73 s-3.13,0.63-4.44,0.1c-1.31-0.53-2.32-2-2.25-3.27s0.34-4.17,0.6-6.46c0.26-2.29,1.15-6.77,1.98-9.96 c0.83-3.19,2.34-7.25,3.36-9.03c1.02-1.78,2.84-3.42,4.06-3.65c1.22-0.23,3.34-0.3,4.73-0.14s3.51,1.23,4.73,2.37 C369,137.79,369.91,139.37,369.82,140.15z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M369.82,140.15c-0.1,0.78,0.06,2.28,0.36,3.32c0.29,1.04,0.61,2.79,0.7,3.88 c0.09,1.09-1.13,2.65-2.71,3.46c-1.58,0.81-4.05,2.82-5.49,4.47s-3.28,4.65-4.1,6.67c-0.82,2.02-2.42,4.15-3.56,4.73 s-3.13,0.63-4.44,0.1c-1.31-0.53-2.32-2-2.25-3.27s0.34-4.17,0.6-6.46c0.26-2.29,1.15-6.77,1.98-9.96 c0.83-3.19,2.34-7.25,3.36-9.03c1.02-1.78,2.84-3.42,4.06-3.65c1.22-0.23,3.34-0.3,4.73-0.14s3.51,1.23,4.73,2.37 C369,137.79,369.91,139.37,369.82,140.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_106_",
    cx: 307.5969,
    cy: 44.0644,
    r: 4.3419,
    gradientTransform: "matrix(-0.7446 0.7988 -0.7988 -0.7446 624.4035 -66.1477)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    style: {
      stopColor: "#B3DAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9166,
    style: {
      stopColor: "#77C1D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#6EBED0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6EBED0"
    }
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    className: "st110",
    cx: 360.16,
    cy: 146.75,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_107_",
    cx: 219.2173,
    cy: 183.6373,
    r: 13.5036,
    gradientTransform: "matrix(0.8924 0.4513 -0.4513 0.8924 215.3626 -102.0522)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#887EB3"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M314.24,155c1.71-0.72,4.27-2.23,5.69-3.37c1.42-1.14,3.38-2.39,4.36-2.78c0.98-0.39,3.59,0.59,5.81,2.18 c2.22,1.59,5.47,3.23,7.23,3.66c1.76,0.43,4.45,1.64,5.99,2.69c1.53,1.05,2.59,2.99,2.35,4.3c-0.24,1.31-1.47,3.16-2.73,4.11 c-1.26,0.95-4.56,1.57-7.33,1.38s-6.27,0.01-7.77,0.46c-1.5,0.45-3.89,0.69-5.3,0.53c-1.41-0.15-3.95-0.99-5.66-1.85 c-1.7-0.86-3.66-2.34-4.34-3.29c-0.69-0.95-1.28-2.85-1.33-4.22C311.17,157.42,312.53,155.72,314.24,155z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.24,155c1.71-0.72,4.27-2.23,5.69-3.37c1.42-1.14,3.38-2.39,4.36-2.78c0.98-0.39,3.59,0.59,5.81,2.18 c2.22,1.59,5.47,3.23,7.23,3.66c1.76,0.43,4.45,1.64,5.99,2.69c1.53,1.05,2.59,2.99,2.35,4.3c-0.24,1.31-1.47,3.16-2.73,4.11 c-1.26,0.95-4.56,1.57-7.33,1.38s-6.27,0.01-7.77,0.46c-1.5,0.45-3.89,0.69-5.3,0.53c-1.41-0.15-3.95-0.99-5.66-1.85 c-1.7-0.86-3.66-2.34-4.34-3.29c-0.69-0.95-1.28-2.85-1.33-4.22C311.17,157.42,312.53,155.72,314.24,155z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_108_",
    cx: 348.3741,
    cy: 123.2577,
    r: 4.3419,
    gradientTransform: "matrix(0.861 -0.6717 0.6717 0.861 -55.664 287.5638)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#887EB3"
    }
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    className: "st112",
    cx: 327.09,
    cy: 159.7,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_109_",
    cx: 190.4018,
    cy: 271.2374,
    r: 13.0163,
    gradientTransform: "matrix(0.8763 0.4817 -0.4817 0.8763 292.8237 -151.4888)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#887EB3"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M321.2,163.8c1.45-0.84,4.8-0.51,7.45,0.73c2.65,1.24,5.01,3.75,5.24,5.58c0.23,1.82,0.62,5.11,0.85,7.31 c0.24,2.19,1.44,5.39,2.67,7.11c1.23,1.72,1.98,3.87,1.67,4.79s-2.48,2.47-4.82,3.46c0,0,0,0-0.48,0.25 c-0.48,0.25-0.48,0.25-0.48,0.25c-2.6-1.15-6.1-3.07-7.78-4.28c-1.68-1.2-4.21-3.03-5.64-4.05c-1.43-1.02-2.77-3.54-2.98-5.6 c-0.21-2.06,0.08-6.05,0.65-8.88C318.1,167.64,319.75,164.64,321.2,163.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.2,163.8c1.45-0.84,4.8-0.51,7.45,0.73c2.65,1.24,5.01,3.75,5.24,5.58c0.23,1.82,0.62,5.11,0.85,7.31 c0.24,2.19,1.44,5.39,2.67,7.11c1.23,1.72,1.98,3.87,1.67,4.79s-2.48,2.47-4.82,3.46c0,0,0,0-0.48,0.25 c-0.48,0.25-0.48,0.25-0.48,0.25c-2.6-1.15-6.1-3.07-7.78-4.28c-1.68-1.2-4.21-3.03-5.64-4.05c-1.43-1.02-2.77-3.54-2.98-5.6 c-0.21-2.06,0.08-6.05,0.65-8.88C318.1,167.64,319.75,164.64,321.2,163.8z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_110_",
    cx: 263.8639,
    cy: 134.9544,
    r: 4.3419,
    gradientTransform: "matrix(0.8836 -0.6417 0.6417 0.8836 8.5872 228.5976)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#887EB3"
    }
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    className: "st114",
    cx: 328.34,
    cy: 178.51,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_111_",
    cx: 347.795,
    cy: 170.0502,
    r: 13.7374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#887EB3"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M338.26,161.87c0.75-0.53,2.45-1.52,3.77-2.19c1.32-0.67,3.65-1.46,5.17-1.75 c1.52-0.29,4.03-0.13,5.58,0.35c1.55,0.48,4.18,1.63,5.83,2.56c1.66,0.93,3.49,3.25,4.07,5.16c0.58,1.91-0.2,4.21-1.73,5.13 c-1.53,0.91-4.63,2.28-6.89,3.04c-2.26,0.76-4.9,2.46-5.88,3.77c-0.98,1.31-2.8,2.96-4.04,3.67s-3.56,0.91-5.14,0.45 c-1.58-0.46-3.21-2.46-3.62-4.45s-1.42-5.2-2.25-7.12c-0.83-1.93-0.32-4.44,1.13-5.58C335.71,163.77,337.51,162.4,338.26,161.87z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.26,161.87c0.75-0.53,2.45-1.52,3.77-2.19c1.32-0.67,3.65-1.46,5.17-1.75c1.52-0.29,4.03-0.13,5.58,0.35 c1.55,0.48,4.18,1.63,5.83,2.56c1.66,0.93,3.49,3.25,4.07,5.16c0.58,1.91-0.2,4.21-1.73,5.13c-1.53,0.91-4.63,2.28-6.89,3.04 c-2.26,0.76-4.9,2.46-5.88,3.77c-0.98,1.31-2.8,2.96-4.04,3.67s-3.56,0.91-5.14,0.45c-1.58-0.46-3.21-2.46-3.62-4.45 s-1.42-5.2-2.25-7.12c-0.83-1.93-0.32-4.44,1.13-5.58C335.71,163.77,337.51,162.4,338.26,161.87z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_112_",
    cx: 410.1498,
    cy: 224.7392,
    r: 4.3419,
    gradientTransform: "matrix(0.4652 -0.988 0.988 0.4652 -66.0011 469.9998)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#887EB3"
    }
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    className: "st116",
    cx: 346.84,
    cy: 169.32,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_113_",
    cx: 333.4008,
    cy: 153.3308,
    r: 15.3826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#887EB3"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M315.18,150.74c0,0.25,1.22,1.13,2.71,1.96s3.91,1.51,5.36,1.51c1.46,0,4.69,0.37,7.17,0.83 c2.49,0.46,4.86,1.95,5.28,3.32c0.41,1.37,0.89,3.47,1.06,4.67c0.17,1.2,1.35,2.19,2.64,2.19s3.29-0.58,4.45-1.28 s2.92-2.88,3.92-4.82c1-1.95,2.35-4.8,3.02-6.33c0.66-1.53,1-4.52,0.75-6.63s-2.01-4.12-3.92-4.45c-1.91-0.33-5.2-0.33-7.31,0 c-2.11,0.33-6.57,0.33-9.89,0c-3.33-0.33-6.89-0.13-7.93,0.45s-2.84,1.56-4,2.19c-1.17,0.62-2.39,2.22-2.71,3.54 S315.18,150.49,315.18,150.74z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.18,150.74c0,0.25,1.22,1.13,2.71,1.96s3.91,1.51,5.36,1.51c1.46,0,4.69,0.37,7.17,0.83 c2.49,0.46,4.86,1.95,5.28,3.32c0.41,1.37,0.89,3.47,1.06,4.67c0.17,1.2,1.35,2.19,2.64,2.19s3.29-0.58,4.45-1.28 s2.92-2.88,3.92-4.82c1-1.95,2.35-4.8,3.02-6.33c0.66-1.53,1-4.52,0.75-6.63s-2.01-4.12-3.92-4.45c-1.91-0.33-5.2-0.33-7.31,0 c-2.11,0.33-6.57,0.33-9.89,0c-3.33-0.33-6.89-0.13-7.93,0.45s-2.84,1.56-4,2.19c-1.17,0.62-2.39,2.22-2.71,3.54 S315.18,150.49,315.18,150.74z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_114_",
    cx: 420.8534,
    cy: 207.3645,
    r: 4.3419,
    gradientTransform: "matrix(0.4652 -0.988 0.988 0.4652 -66.0011 469.9998)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#887EB3"
    }
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    className: "st118",
    cx: 334.66,
    cy: 150.66,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_115_",
    cx: 364.1471,
    cy: 184.5946,
    r: 17.5917,
    gradientTransform: "matrix(0.994 -0.1095 0.1095 0.994 -49.239 46.7918)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2901,
    style: {
      stopColor: "#EED9E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5881,
    style: {
      stopColor: "#E2BCD3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8336,
    style: {
      stopColor: "#DBABC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D9A4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D9A4C4"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M323.26,195.23c0.4-1.8,1.81-4.27,3.12-5.5s3.73-3.1,5.36-4.16c1.63-1.06,3.19-2.82,3.46-3.93 c0.27-1.11,0.81-2.53,1.19-3.16s1.68-1.26,2.88-1.39c1.2-0.13,2.97,0.46,3.94,1.33s2.24,2.21,2.82,2.99s1.19,2.55,1.34,3.93 c0.15,1.38,0.28,3.81,0.29,5.39c0.01,1.58-0.16,3.75-0.38,4.82c-0.21,1.07-1,2.45-1.74,3.07s-2.15,1.22-3.13,1.33 c-0.98,0.11-3.19,0.35-4.92,0.54s-3.78,0.76-4.56,1.26c-0.78,0.5-2.62,1.05-4.1,1.21c-1.47,0.16-2.93-0.12-3.24-0.63 c-0.31-0.51-1.13-1.58-1.82-2.38C323.09,199.15,322.86,197.03,323.26,195.23z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.26,195.23c0.4-1.8,1.81-4.27,3.12-5.5s3.73-3.1,5.36-4.16c1.63-1.06,3.19-2.82,3.46-3.93 c0.27-1.11,0.81-2.53,1.19-3.16s1.68-1.26,2.88-1.39c1.2-0.13,2.97,0.46,3.94,1.33s2.24,2.21,2.82,2.99s1.19,2.55,1.34,3.93 c0.15,1.38,0.28,3.81,0.29,5.39c0.01,1.58-0.16,3.75-0.38,4.82c-0.21,1.07-1,2.45-1.74,3.07s-2.15,1.22-3.13,1.33 c-0.98,0.11-3.19,0.35-4.92,0.54s-3.78,0.76-4.56,1.26c-0.78,0.5-2.62,1.05-4.1,1.21c-1.47,0.16-2.93-0.12-3.24-0.63 c-0.31-0.51-1.13-1.58-1.82-2.38C323.09,199.15,322.86,197.03,323.26,195.23z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_116_",
    cx: 46.0569,
    cy: 112.503,
    r: 4.3419,
    gradientTransform: "matrix(-1.0897 0.0716 -0.0716 -1.0899 392.6375 311.115)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    className: "st120",
    cx: 334.39,
    cy: 191.8,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_117_",
    cx: 317.079,
    cy: 222.183,
    r: 16.2196,
    gradientTransform: "matrix(0.9875 0.1573 -0.1573 0.9875 89.4832 -75.1051)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2901,
    style: {
      stopColor: "#EED9E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5881,
    style: {
      stopColor: "#E2BCD3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8336,
    style: {
      stopColor: "#DBABC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D9A4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D9A4C4"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M364.27,184.19c-1.82,2.23-3.57,5.63-3.87,7.55s-1.1,5.2-1.77,7.28c-0.67,2.08-0.32,4.88,0.76,6.22 s3.78,2.12,5.98,1.73c2.2-0.39,5.85-2.38,8.11-4.42c2.26-2.04,4.75-5.39,5.54-7.45s1.05-5.62,0.58-7.92s-2.03-4.61-3.46-5.13 c-1.43-0.52-3.94-1.16-5.57-1.42C368.93,180.35,366.1,181.96,364.27,184.19z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.27,184.19c-1.82,2.23-3.57,5.63-3.87,7.55s-1.1,5.2-1.77,7.28c-0.67,2.08-0.32,4.88,0.76,6.22 s3.78,2.12,5.98,1.73c2.2-0.39,5.85-2.38,8.11-4.42c2.26-2.04,4.75-5.39,5.54-7.45s1.05-5.62,0.58-7.92s-2.03-4.61-3.46-5.13 c-1.43-0.52-3.94-1.16-5.57-1.42C368.93,180.35,366.1,181.96,364.27,184.19z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_118_",
    cx: 64.5081,
    cy: 138.1676,
    r: 4.3419,
    gradientTransform: "matrix(-1.0874 -0.1007 0.1007 -1.0876 425.1597 351.3812)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    className: "st122",
    cx: 368.93,
    cy: 194.61,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_119_",
    cx: 360.8664,
    cy: 158.2891,
    r: 18.3043,
    gradientTransform: "matrix(0.9863 -0.1651 0.1651 0.9863 -73.6529 73.5397)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2901,
    style: {
      stopColor: "#EED9E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5881,
    style: {
      stopColor: "#E2BCD3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8336,
    style: {
      stopColor: "#DBABC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D9A4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D9A4C4"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M305.98,152.72c2.03-0.76,4.49,0.17,5.48,2.06c0.99,1.89,2.47,4.57,3.3,5.94s2.22,3.34,3.1,4.37 c0.88,1.03,0.99,2.8,0.25,3.93s-1.43,3.76-1.54,5.84c-0.11,2.08,0.16,5.35,0.61,7.26c0.45,1.91-0.26,3.65-1.57,3.87 c-1.31,0.22-3.59,0.6-5.07,0.85c-1.48,0.25-2.93-0.98-3.23-2.74s-1.54-4.69-2.76-6.53c-1.22-1.84-2.84-5.16-3.59-7.38 c-0.75-2.22-0.96-5.1-0.46-6.4c0.5-1.3,1.1-4.02,1.34-6.03C302.1,155.75,303.95,153.48,305.98,152.72z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305.98,152.72c2.03-0.76,4.49,0.17,5.48,2.06c0.99,1.89,2.47,4.57,3.3,5.94s2.22,3.34,3.1,4.37 c0.88,1.03,0.99,2.8,0.25,3.93s-1.43,3.76-1.54,5.84c-0.11,2.08,0.16,5.35,0.61,7.26c0.45,1.91-0.26,3.65-1.57,3.87 c-1.31,0.22-3.59,0.6-5.07,0.85c-1.48,0.25-2.93-0.98-3.23-2.74s-1.54-4.69-2.76-6.53c-1.22-1.84-2.84-5.16-3.59-7.38 c-0.75-2.22-0.96-5.1-0.46-6.4c0.5-1.3,1.1-4.02,1.34-6.03C302.1,155.75,303.95,153.48,305.98,152.72z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_120_",
    cx: -50.4283,
    cy: 250.8006,
    r: 4.3419,
    gradientTransform: "matrix(-0.9288 -0.5744 0.5745 -0.929 117.9091 372.5728)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    className: "st124",
    cx: 308.83,
    cy: 168.56,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_121_",
    cx: 410.6141,
    cy: 115.8327,
    r: 12.7548,
    gradientTransform: "matrix(-0.6815 0.7318 -0.7318 -0.6815 709.1647 -84.2803)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFF0F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    style: {
      stopColor: "#D5ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    style: {
      stopColor: "#BDE0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A6D6E3"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M329.61,132.59c-0.62,0.62,0.06,2.58,1.52,4.37c1.46,1.79,2.92,4.4,3.26,5.81s1.5,2.55,2.59,2.52 c1.09-0.02,3.8,0.1,6.01,0.28c2.22,0.18,4.83,0.79,5.82,1.35c0.99,0.56,3.5,0.45,5.6-0.24c2.09-0.69,4.35-2.06,5.02-3.03 s0.43-3.29-0.52-5.14c-0.95-1.86-2.86-4.02-4.24-4.8s-3.84-2.05-5.47-2.81c-1.63-0.76-4.99-1.99-7.46-2.73 c-2.47-0.73-5.19-1-6.03-0.59s-2.3,1.46-3.25,2.32C331.52,130.77,330.23,131.98,329.61,132.59z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M329.61,132.59c-0.62,0.62,0.06,2.58,1.52,4.37c1.46,1.79,2.92,4.4,3.26,5.81s1.5,2.55,2.59,2.52 c1.09-0.02,3.8,0.1,6.01,0.28c2.22,0.18,4.83,0.79,5.82,1.35c0.99,0.56,3.5,0.45,5.6-0.24c2.09-0.69,4.35-2.06,5.02-3.03 s0.43-3.29-0.52-5.14c-0.95-1.86-2.86-4.02-4.24-4.8s-3.84-2.05-5.47-2.81c-1.63-0.76-4.99-1.99-7.46-2.73 c-2.47-0.73-5.19-1-6.03-0.59s-2.3,1.46-3.25,2.32C331.52,130.77,330.23,131.98,329.61,132.59z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_122_",
    cx: 163.1354,
    cy: 384.4356,
    r: 4.3419,
    gradientTransform: "matrix(-0.7446 0.7988 -0.7988 -0.7446 772.9937 293.2202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    style: {
      stopColor: "#B3DAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9166,
    style: {
      stopColor: "#77C1D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#6EBED0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6EBED0"
    }
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    className: "st126",
    cx: 344.43,
    cy: 137.27,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_123_",
    cx: 278.6642,
    cy: 168.171,
    r: 14.7698,
    gradientTransform: "matrix(-0.7729 0.4748 -0.4824 -0.7622 594.6763 192.9978)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFF0F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    style: {
      stopColor: "#D5ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    style: {
      stopColor: "#BDE0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A6D6E3"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M282.74,194.2c0.42-1.06,1.51-3.03,2.42-4.39c0.91-1.36,2.6-2.59,3.76-2.75c1.16-0.16,2.83,0.93,3.7,2.41 c0.87,1.48,2.9,3.4,4.5,4.27c1.61,0.87,4.29,1.38,5.96,1.12c1.67-0.25,4.4-0.42,6.06-0.37c1.66,0.05,3.33,1.1,3.71,2.33 c0.38,1.23,0.96,3.49,1.29,5.03s-0.1,3.39-0.95,4.13s-3.07,1.29-4.92,1.23c-1.85-0.06-5.15-0.16-7.34-0.23 c-2.19-0.07-5.89-0.18-8.23-0.25c-2.34-0.07-5.46-0.17-6.94-0.21c-1.48-0.05-2.97-1.25-3.31-2.68c-0.34-1.43-0.59-3.75-0.55-5.16 C281.94,197.28,282.32,195.26,282.74,194.2z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M282.74,194.2c0.42-1.06,1.51-3.03,2.42-4.39c0.91-1.36,2.6-2.59,3.76-2.75c1.16-0.16,2.83,0.93,3.7,2.41 c0.87,1.48,2.9,3.4,4.5,4.27c1.61,0.87,4.29,1.38,5.96,1.12c1.67-0.25,4.4-0.42,6.06-0.37c1.66,0.05,3.33,1.1,3.71,2.33 c0.38,1.23,0.96,3.49,1.29,5.03s-0.1,3.39-0.95,4.13s-3.07,1.29-4.92,1.23c-1.85-0.06-5.15-0.16-7.34-0.23 c-2.19-0.07-5.89-0.18-8.23-0.25c-2.34-0.07-5.46-0.17-6.94-0.21c-1.48-0.05-2.97-1.25-3.31-2.68c-0.34-1.43-0.59-3.75-0.55-5.16 C281.94,197.28,282.32,195.26,282.74,194.2z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_124_",
    cx: 289.1911,
    cy: 324.7884,
    r: 4.3419,
    gradientTransform: "matrix(-0.7446 0.7988 -0.7988 -0.7446 769.931 209.9703)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    style: {
      stopColor: "#B3DAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9166,
    style: {
      stopColor: "#77C1D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#6EBED0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6EBED0"
    }
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    className: "st128",
    cx: 295.15,
    cy: 199.13,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_125_",
    cx: 357.7371,
    cy: 213.843,
    r: 16.0047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CACFE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2831,
    style: {
      stopColor: "#C6CCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5169,
    style: {
      stopColor: "#BBC2DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7331,
    style: {
      stopColor: "#A9B3D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    style: {
      stopColor: "#919FC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8998C1"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M355.15,203.24c-0.75-1.15,0.14-2.75,1.96-3.54c1.82-0.8,4.47-0.8,5.87,0c1.41,0.8,4.06,3.47,5.89,5.94 c0,0,0,0,0.15,0.75c0.15,0.75,0.15,0.75,0.15,0.75c0.5,3.78,0.74,9.38,0.53,12.44c-0.21,3.06-1.59,6.29-3.07,7.19 c-1.48,0.9-4.06,1.43-5.73,1.18s-4.18-0.45-5.57-0.45c-1.39,0-3.53-0.42-4.75-0.93c-1.22-0.51-1.74-1.87-1.16-3.02 s2.01-2.91,3.17-3.91s2.32-3.48,2.58-5.49s0.67-4.82,0.9-6.24C356.31,206.5,355.89,204.4,355.15,203.24z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M355.15,203.24c-0.75-1.15,0.14-2.75,1.96-3.54c1.82-0.8,4.47-0.8,5.87,0c1.41,0.8,4.06,3.47,5.89,5.94 c0,0,0,0,0.15,0.75c0.15,0.75,0.15,0.75,0.15,0.75c0.5,3.78,0.74,9.38,0.53,12.44c-0.21,3.06-1.59,6.29-3.07,7.19 c-1.48,0.9-4.06,1.43-5.73,1.18s-4.18-0.45-5.57-0.45c-1.39,0-3.53-0.42-4.75-0.93c-1.22-0.51-1.74-1.87-1.16-3.02 s2.01-2.91,3.17-3.91s2.32-3.48,2.58-5.49s0.67-4.82,0.9-6.24C356.31,206.5,355.89,204.4,355.15,203.24z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_126_",
    cx: 284.4123,
    cy: 192.0553,
    r: 4.3419,
    gradientTransform: "matrix(0.6782 0.8559 -0.8561 0.6783 333.8262 -158.4738)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8998C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D5F99"
    }
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    className: "st130",
    cx: 362.3,
    cy: 215.24,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_127_",
    cx: 216.7074,
    cy: 292.9872,
    r: 13.1103,
    gradientTransform: "matrix(-0.9292 -0.3695 0.3696 -0.9294 444.6945 550.7126)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFF0F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    style: {
      stopColor: "#D5ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    style: {
      stopColor: "#BDE0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A6D6E3"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M342.01,197.35c1.08-1.59,4.22-3.4,6.98-4.02s6.31-2.78,7.87-4.79c1.57-2.01,3.64-3.46,4.61-3.23 c0.97,0.23,1.46,1.82,1.08,3.52c-0.37,1.7-1.82,5.49-3.21,8.41c-1.39,2.92-2.37,6.88-2.19,8.81c0.19,1.93-0.61,4.29-1.76,5.26 c-1.15,0.97-3.41,2-5.01,2.29c-1.6,0.29-4.23-0.09-5.84-0.86c-1.61-0.77-3.69-2.17-4.61-3.11c-0.93-0.95-1.49-2.45-1.25-3.35 s0.65-2.62,0.9-3.83C339.84,201.22,340.93,198.93,342.01,197.35z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M342.01,197.35c1.08-1.59,4.22-3.4,6.98-4.02s6.31-2.78,7.87-4.79c1.57-2.01,3.64-3.46,4.61-3.23 c0.97,0.23,1.46,1.82,1.08,3.52c-0.37,1.7-1.82,5.49-3.21,8.41c-1.39,2.92-2.37,6.88-2.19,8.81c0.19,1.93-0.61,4.29-1.76,5.26 c-1.15,0.97-3.41,2-5.01,2.29c-1.6,0.29-4.23-0.09-5.84-0.86c-1.61-0.77-3.69-2.17-4.61-3.11c-0.93-0.95-1.49-2.45-1.25-3.35 s0.65-2.62,0.9-3.83C339.84,201.22,340.93,198.93,342.01,197.35z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_128_",
    cx: 364.2963,
    cy: 249.5518,
    r: 4.3419,
    gradientTransform: "matrix(-0.7446 0.7988 -0.7988 -0.7446 821.0981 96.0171)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    style: {
      stopColor: "#B3DAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9166,
    style: {
      stopColor: "#77C1D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#6EBED0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6EBED0"
    }
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    className: "st132",
    cx: 350.49,
    cy: 201.19,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_129_",
    cx: 807.4853,
    cy: 365.7896,
    r: 15.5933,
    gradientTransform: "matrix(0.2834 -0.8405 0.9436 0.2913 -229.3436 697.1989)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CACFE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2831,
    style: {
      stopColor: "#C6CCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5169,
    style: {
      stopColor: "#BBC2DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7331,
    style: {
      stopColor: "#A9B3D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    style: {
      stopColor: "#919FC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8998C1"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M354.95,131.86c0.38-0.16,0.67-1.63,0.64-3.27c-0.03-1.64,0.23-3.87,0.58-4.95 c0.34-1.08,0.16-2.66-0.41-3.5c-0.57-0.84-2.04-2.06-3.27-2.69c-1.23-0.64-3.64-1.37-5.37-1.64c-1.72-0.26-4.71-0.46-6.64-0.44 c-1.93,0.02-4.05-0.48-4.72-1.13s-2.32-0.4-3.66,0.55c-1.35,0.94-2.2,3.2-1.9,5.02c0.3,1.82,0.84,4.57,1.2,6.11 c0.36,1.54,1.43,3.18,2.37,3.64c0.94,0.46,3.07,0.6,4.73,0.3c1.65-0.29,4.13-0.33,5.49-0.09c1.37,0.25,3.01,1.12,3.66,1.94 c0.64,0.82,2.39,1.25,3.89,0.96S354.57,132.01,354.95,131.86z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.95,131.86c0.38-0.16,0.67-1.63,0.64-3.27c-0.03-1.64,0.23-3.87,0.58-4.95c0.34-1.08,0.16-2.66-0.41-3.5 c-0.57-0.84-2.04-2.06-3.27-2.69c-1.23-0.64-3.64-1.37-5.37-1.64c-1.72-0.26-4.71-0.46-6.64-0.44c-1.93,0.02-4.05-0.48-4.72-1.13 s-2.32-0.4-3.66,0.55c-1.35,0.94-2.2,3.2-1.9,5.02c0.3,1.82,0.84,4.57,1.2,6.11c0.36,1.54,1.43,3.18,2.37,3.64 c0.94,0.46,3.07,0.6,4.73,0.3c1.65-0.29,4.13-0.33,5.49-0.09c1.37,0.25,3.01,1.12,3.66,1.94c0.64,0.82,2.39,1.25,3.89,0.96 S354.57,132.01,354.95,131.86z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_130_",
    cx: 321.0952,
    cy: -153.6727,
    r: 4.3419,
    gradientTransform: "matrix(0.3692 1.0277 -1.0279 0.3693 68.7356 -149.1176)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8998C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D5F99"
    }
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    className: "st134",
    cx: 345.26,
    cy: 124.13,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_131_",
    cx: 284.8246,
    cy: 144.8624,
    r: 18.1749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CACFE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2831,
    style: {
      stopColor: "#C6CCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5169,
    style: {
      stopColor: "#BBC2DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7331,
    style: {
      stopColor: "#A9B3D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    style: {
      stopColor: "#919FC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8998C1"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M275.95,152.14c1.33,0.37,4.35,0.95,6.72,1.28c2.37,0.33,5.15,1.04,6.18,1.58 c1.03,0.54,2.64,0.62,3.58,0.19c0.94-0.44,2.16-1.66,2.71-2.71c0.55-1.06,1.56-2.57,2.23-3.35c0.67-0.79,1.69-2.31,2.26-3.39 c0.57-1.08,1.35-3.15,1.72-4.6c0.37-1.45-0.1-3.69-1.05-4.98c-0.95-1.29-3.26-2.34-5.13-2.34c-1.87,0-4.8,0.14-6.49,0.32 c-1.7,0.18-3.96,0.86-5.03,1.51s-3.23,1.76-4.8,2.47s-3.44,1.79-4.16,2.41c-0.72,0.62-1.44,2.15-1.6,3.39 c-0.17,1.24-0.13,3.45,0.08,4.9C273.37,150.28,274.63,151.77,275.95,152.14z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.95,152.14c1.33,0.37,4.35,0.95,6.72,1.28c2.37,0.33,5.15,1.04,6.18,1.58c1.03,0.54,2.64,0.62,3.58,0.19 c0.94-0.44,2.16-1.66,2.71-2.71c0.55-1.06,1.56-2.57,2.23-3.35c0.67-0.79,1.69-2.31,2.26-3.39c0.57-1.08,1.35-3.15,1.72-4.6 c0.37-1.45-0.1-3.69-1.05-4.98c-0.95-1.29-3.26-2.34-5.13-2.34c-1.87,0-4.8,0.14-6.49,0.32c-1.7,0.18-3.96,0.86-5.03,1.51 s-3.23,1.76-4.8,2.47s-3.44,1.79-4.16,2.41c-0.72,0.62-1.44,2.15-1.6,3.39c-0.17,1.24-0.13,3.45,0.08,4.9 C273.37,150.28,274.63,151.77,275.95,152.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_132_",
    cx: -14.3986,
    cy: 166.6606,
    r: 4.3419,
    gradientTransform: "matrix(-1.091 -0.0482 0.0482 -1.0912 263.2458 326.072)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8998C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D5F99"
    }
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    className: "st136",
    cx: 286.98,
    cy: 144.91,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_133_",
    cx: 696.3835,
    cy: 134.9497,
    r: 15.2985,
    gradientTransform: "matrix(0.5822 -0.8131 0.8131 0.5822 -132.3323 642.2058)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CACFE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2831,
    style: {
      stopColor: "#C6CCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5169,
    style: {
      stopColor: "#BBC2DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7331,
    style: {
      stopColor: "#A9B3D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    style: {
      stopColor: "#919FC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8998C1"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M376.78,162.69c0.15,1.79,1.76,4.14,3.57,5.22c1.81,1.08,3.79,1.92,4.4,1.87 c0.61-0.05,1.79-1.04,2.63-2.21c0.84-1.17,2.47-3.45,3.63-5.08c1.16-1.62,2.1-4.02,2.08-5.33c-0.02-1.31-0.03-3.69-0.03-5.3 s-0.99-3.88-2.21-5.05c-1.22-1.17-3.14-2.8-4.28-3.62c-1.14-0.81-3.64-1.48-5.56-1.47c-1.92,0.01-4.19,1-5.06,2.21 c-0.86,1.21-1.15,3.19-0.64,4.41c0.51,1.22,1.63,3.37,2.49,4.78s0.91,3.4,0.13,4.44C377.15,158.59,376.63,160.9,376.78,162.69z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M376.78,162.69c0.15,1.79,1.76,4.14,3.57,5.22c1.81,1.08,3.79,1.92,4.4,1.87 c0.61-0.05,1.79-1.04,2.63-2.21c0.84-1.17,2.47-3.45,3.63-5.08c1.16-1.62,2.1-4.02,2.08-5.33c-0.02-1.31-0.03-3.69-0.03-5.3 s-0.99-3.88-2.21-5.05c-1.22-1.17-3.14-2.8-4.28-3.62c-1.14-0.81-3.64-1.48-5.56-1.47c-1.92,0.01-4.19,1-5.06,2.21 c-0.86,1.21-1.15,3.19-0.64,4.41c0.51,1.22,1.63,3.37,2.49,4.78s0.91,3.4,0.13,4.44C377.15,158.59,376.63,160.9,376.78,162.69z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_134_",
    cx: 109.2093,
    cy: -186.4944,
    r: 4.3419,
    gradientTransform: "matrix(-0.6743 0.859 -0.8592 -0.6744 297.2715 -63.1819)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8998C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D5F99"
    }
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    className: "st138",
    cx: 383.87,
    cy: 156.4,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_135_",
    cx: -147.4829,
    cy: 414.8512,
    r: 17.5917,
    gradientTransform: "matrix(-0.0147 0.9999 -0.9999 -0.0147 693.4861 337.8574)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CACFE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2831,
    style: {
      stopColor: "#C6CCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5169,
    style: {
      stopColor: "#BBC2DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7331,
    style: {
      stopColor: "#A9B3D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    style: {
      stopColor: "#919FC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8998C1"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st139",
    d: "M277.24,174.1c1.73,0.62,4.01,2.32,5.07,3.78c1.06,1.46,2.61,4.08,3.46,5.84 c0.85,1.75,2.41,3.52,3.47,3.92c1.06,0.41,2.41,1.11,2.99,1.57c0.58,0.46,1.04,1.82,1.03,3.03c-0.02,1.21-0.83,2.89-1.8,3.74 c-0.97,0.85-2.47,1.94-3.32,2.43c-0.85,0.49-2.68,0.87-4.07,0.85c-1.39-0.02-3.81-0.19-5.39-0.38c-1.57-0.19-3.7-0.63-4.74-0.97 c-1.03-0.34-2.31-1.29-2.83-2.1s-0.95-2.28-0.93-3.27c0.01-0.99,0.05-3.21,0.07-4.95c0.03-1.74-0.28-3.84-0.69-4.68 c-0.4-0.84-0.71-2.73-0.69-4.22c0.02-1.48,0.48-2.89,1.03-3.14c0.54-0.25,1.71-0.93,2.59-1.51 C273.37,173.45,275.5,173.48,277.24,174.1z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.24,174.1c1.73,0.62,4.01,2.32,5.07,3.78c1.06,1.46,2.61,4.08,3.46,5.84c0.85,1.75,2.41,3.52,3.47,3.92 c1.06,0.41,2.41,1.11,2.99,1.57c0.58,0.46,1.04,1.82,1.03,3.03c-0.02,1.21-0.83,2.89-1.8,3.74c-0.97,0.85-2.47,1.94-3.32,2.43 c-0.85,0.49-2.68,0.87-4.07,0.85c-1.39-0.02-3.81-0.19-5.39-0.38c-1.57-0.19-3.7-0.63-4.74-0.97c-1.03-0.34-2.31-1.29-2.83-2.1 s-0.95-2.28-0.93-3.27c0.01-0.99,0.05-3.21,0.07-4.95c0.03-1.74-0.28-3.84-0.69-4.68c-0.4-0.84-0.71-2.73-0.69-4.22 c0.02-1.48,0.48-2.89,1.03-3.14c0.54-0.25,1.71-0.93,2.59-1.51C273.37,173.45,275.5,173.48,277.24,174.1z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_136_",
    cx: 80.2544,
    cy: 625.1307,
    r: 4.3419,
    gradientTransform: "matrix(0.0642 -1.0902 1.0904 0.0642 -407.5019 232.9513)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8998C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D5F99"
    }
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    className: "st140",
    cx: 279.27,
    cy: 185.57,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_137_",
    cx: 141.5613,
    cy: 229.6723,
    r: 11.5082,
    gradientTransform: "matrix(0.9781 -0.208 0.4349 2.0445 40.2162 -273.9677)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CACFE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2831,
    style: {
      stopColor: "#C6CCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5169,
    style: {
      stopColor: "#BBC2DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7331,
    style: {
      stopColor: "#A9B3D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    style: {
      stopColor: "#919FC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8998C1"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M274.21,152.31c0.76-1.46,2.43-1.97,3.7-1.13s3.05,1.84,3.94,2.22s2.59,1.26,3.78,1.97s2.33,2.1,2.55,3.1 c0.22,1,0.13,2.33-0.19,2.96c-0.33,0.63-0.86,2.18-1.19,3.46c-0.33,1.28-0.65,3.37-0.71,4.65c-0.06,1.28,0.49,3.14,1.21,4.14 c0.72,1,1.12,2.77,0.88,3.94c-0.24,1.17-0.72,2.67-1.07,3.33c-0.34,0.66-1.48,1.26-2.53,1.32c-1.04,0.06-2.68-0.29-3.63-0.79 s-2.23-1.16-2.85-1.49s-1.37-1.4-1.67-2.4c-0.3-1-0.71-2.59-0.92-3.54c-0.21-0.95-0.93-2.88-1.6-4.3 c-0.68-1.41-1.61-3.35-2.08-4.31c-0.47-0.96-1-2.62-1.19-3.7c-0.19-1.08,0.23-3.04,0.92-4.37S273.44,153.77,274.21,152.31z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.21,152.31c0.76-1.46,2.43-1.97,3.7-1.13s3.05,1.84,3.94,2.22s2.59,1.26,3.78,1.97s2.33,2.1,2.55,3.1 c0.22,1,0.13,2.33-0.19,2.96c-0.33,0.63-0.86,2.18-1.19,3.46c-0.33,1.28-0.65,3.37-0.71,4.65c-0.06,1.28,0.49,3.14,1.21,4.14 c0.72,1,1.12,2.77,0.88,3.94c-0.24,1.17-0.72,2.67-1.07,3.33c-0.34,0.66-1.48,1.26-2.53,1.32c-1.04,0.06-2.68-0.29-3.63-0.79 s-2.23-1.16-2.85-1.49s-1.37-1.4-1.67-2.4c-0.3-1-0.71-2.59-0.92-3.54c-0.21-0.95-0.93-2.88-1.6-4.3 c-0.68-1.41-1.61-3.35-2.08-4.31c-0.47-0.96-1-2.62-1.19-3.7c-0.19-1.08,0.23-3.04,0.92-4.37S273.44,153.77,274.21,152.31z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_138_",
    cx: 11.9262,
    cy: 317.4558,
    r: 4.3419,
    gradientTransform: "matrix(-0.9452 -0.5469 0.547 -0.9454 117.3502 472.9707)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8998C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D5F99"
    }
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    className: "st142",
    cx: 279.72,
    cy: 166.32,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_139_",
    cx: -121.643,
    cy: 823.0974,
    r: 13.6027,
    gradientTransform: "matrix(-0.6968 0.7173 -0.7173 -0.6968 804.9579 876.0212)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFF0F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    style: {
      stopColor: "#D5ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    style: {
      stopColor: "#BDE0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A6D6E3"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M294.4,201.44c-0.72-0.27-2.26,0.49-3.43,1.69c-1.17,1.2-2.97,3.39-4,4.87c-1.03,1.48-1.97,3.41-2.08,4.31 c-0.11,0.89,0.44,2.61,1.23,3.82s2.38,3.61,3.53,5.32c1.15,1.72,3.27,4.65,4.71,6.51c1.44,1.86,3.65,3.78,4.91,4.26 c1.26,0.48,3.25,0.1,4.4-0.86c1.16-0.95,2.98-3.03,4.05-4.6c1.07-1.58,2.98-3.74,4.26-4.82c1.27-1.07,3.08-2.74,4.03-3.71 s1.02-2.85,0.16-4.17c-0.85-1.32-3.22-2.78-5.26-3.24c-2.04-0.46-4.62-0.5-5.74-0.1s-3.06,0.22-4.33-0.42 c-1.26-0.64-2.73-1.87-3.27-2.74s-1.18-2.5-1.43-3.61C295.91,202.85,295.12,201.71,294.4,201.44z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M294.4,201.44c-0.72-0.27-2.26,0.49-3.43,1.69c-1.17,1.2-2.97,3.39-4,4.87c-1.03,1.48-1.97,3.41-2.08,4.31 c-0.11,0.89,0.44,2.61,1.23,3.82s2.38,3.61,3.53,5.32c1.15,1.72,3.27,4.65,4.71,6.51c1.44,1.86,3.65,3.78,4.91,4.26 c1.26,0.48,3.25,0.1,4.4-0.86c1.16-0.95,2.98-3.03,4.05-4.6c1.07-1.58,2.98-3.74,4.26-4.82c1.27-1.07,3.08-2.74,4.03-3.71 s1.02-2.85,0.16-4.17c-0.85-1.32-3.22-2.78-5.26-3.24c-2.04-0.46-4.62-0.5-5.74-0.1s-3.06,0.22-4.33-0.42 c-1.26-0.64-2.73-1.87-3.27-2.74s-1.18-2.5-1.43-3.61C295.91,202.85,295.12,201.71,294.4,201.44z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_140_",
    cx: -311.8706,
    cy: 92.7694,
    r: 4.3419,
    gradientTransform: "matrix(-0.7446 0.7988 -0.7988 -0.7446 140.9358 536.3178)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    style: {
      stopColor: "#B3DAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9166,
    style: {
      stopColor: "#77C1D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#6EBED0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6EBED0"
    }
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    className: "st145",
    cx: 299.06,
    cy: 218.12,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_141_",
    cx: 352.8737,
    cy: 250.2685,
    r: 14.317,
    gradientTransform: "matrix(0.9513 -0.3082 0.3082 0.9513 -126.9518 84.378)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFF0F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    style: {
      stopColor: "#D5ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    style: {
      stopColor: "#BDE0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A6D6E3"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M280.71,198.76c-1.15-0.4-2.8,0.42-3.67,1.83s-2.18,3.54-2.9,4.73c-0.72,1.19-1.23,4.77-1.14,7.97 c0,0,0,0,0.62,0.43s0.62,0.43,0.62,0.43c1.27,2.64,4.41,6.33,6.98,8.2c0,0,0,0,0.64,0.58c0.64,0.58,0.64,0.58,0.64,0.58 c3.93,2.7,8.78,4.78,10.78,4.63c2.01-0.15,4.51-1.46,5.57-2.91c1.06-1.45,1.82-3.87,1.69-5.38c-0.13-1.51-1.8-3.78-3.7-5.03 c-1.91-1.26-4.04-3.06-4.73-4.02c-0.69-0.95-1.62-2.65-2.05-3.78s-1.28-2.95-1.88-4.06c-0.61-1.11-2.06-2.35-3.24-2.75 S281.86,199.17,280.71,198.76z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M280.71,198.76c-1.15-0.4-2.8,0.42-3.67,1.83s-2.18,3.54-2.9,4.73c-0.72,1.19-1.23,4.77-1.14,7.97 c0,0,0,0,0.62,0.43s0.62,0.43,0.62,0.43c1.27,2.64,4.41,6.33,6.98,8.2c0,0,0,0,0.64,0.58c0.64,0.58,0.64,0.58,0.64,0.58 c3.93,2.7,8.78,4.78,10.78,4.63c2.01-0.15,4.51-1.46,5.57-2.91c1.06-1.45,1.82-3.87,1.69-5.38c-0.13-1.51-1.8-3.78-3.7-5.03 c-1.91-1.26-4.04-3.06-4.73-4.02c-0.69-0.95-1.62-2.65-2.05-3.78s-1.28-2.95-1.88-4.06c-0.61-1.11-2.06-2.35-3.24-2.75 S281.86,199.17,280.71,198.76z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_142_",
    cx: 345.4304,
    cy: 261.0249,
    r: 4.3419,
    gradientTransform: "matrix(-0.7446 0.7988 -0.7988 -0.7446 751.2922 132.1098)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    style: {
      stopColor: "#B3DAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9166,
    style: {
      stopColor: "#77C1D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#6EBED0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6EBED0"
    }
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    className: "st147",
    cx: 285.57,
    cy: 213.67,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_143_",
    cx: 493.5836,
    cy: 704.5995,
    r: 16.3387,
    gradientTransform: "matrix(-0.7237 0.5211 -0.4822 -0.6697 1065.2943 351.0548)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFF0F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    style: {
      stopColor: "#D5ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    style: {
      stopColor: "#BDE0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A6D6E3"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M382.87,141.04c-0.34-0.66-1.07-2.36-1.62-3.77s-2.22-3.73-3.71-5.15s-4.69-3.57-7.12-4.78 s-6.28-2.54-8.56-2.96c-2.28-0.42-5.43,0.17-7.01,1.3c-1.57,1.13-2.76,2.89-2.64,3.9s0.65,2.62,1.17,3.59 c0.53,0.96,2.56,2.26,4.51,2.88s4.16,1.7,4.89,2.4c0.73,0.7,1.92,2.09,2.64,3.09s1.25,2.83,1.18,4.06s0.14,3.15,0.48,4.25 c0.34,1.11,2.77,1.77,5.41,1.47c2.64-0.3,5.74-1.46,6.91-2.6c1.17-1.13,2.56-3.06,3.11-4.27S383.21,141.7,382.87,141.04z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M382.87,141.04c-0.34-0.66-1.07-2.36-1.62-3.77s-2.22-3.73-3.71-5.15s-4.69-3.57-7.12-4.78 s-6.28-2.54-8.56-2.96c-2.28-0.42-5.43,0.17-7.01,1.3c-1.57,1.13-2.76,2.89-2.64,3.9s0.65,2.62,1.17,3.59 c0.53,0.96,2.56,2.26,4.51,2.88s4.16,1.7,4.89,2.4c0.73,0.7,1.92,2.09,2.64,3.09s1.25,2.83,1.18,4.06s0.14,3.15,0.48,4.25 c0.34,1.11,2.77,1.77,5.41,1.47c2.64-0.3,5.74-1.46,6.91-2.6c1.17-1.13,2.56-3.06,3.11-4.27S383.21,141.7,382.87,141.04z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_144_",
    cx: 52.4763,
    cy: 504.737,
    r: 4.3419,
    gradientTransform: "matrix(-0.7446 0.7988 -0.7988 -0.7446 811.7507 469.6859)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    style: {
      stopColor: "#B3DAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9166,
    style: {
      stopColor: "#77C1D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#6EBED0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6EBED0"
    }
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    className: "st149",
    cx: 369.49,
    cy: 135.76,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_145_",
    cx: -297.7507,
    cy: 537.3528,
    r: 14.2316,
    gradientTransform: "matrix(-0.5495 0.7723 -0.753 -0.5357 560.6459 740.3594)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFF0F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    style: {
      stopColor: "#D5ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    style: {
      stopColor: "#BDE0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A6D6E3"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M335.22,219.09c-0.1,1.93-1.6,4.56-3.35,5.86s-4.14,3.72-5.32,5.38c-1.18,1.66-2.58,3.62-3.1,4.36 s-2.2,1.13-3.72,0.86s-4.1-0.74-5.74-1.07c-1.64-0.32-3.84-1.06-4.89-1.63c-1.05-0.57-2.7-1.6-3.67-2.29s-1.74-2.19-1.73-3.34 s0.36-2.76,0.75-3.58c0.4-0.82,1.59-2.12,2.66-2.89c1.07-0.77,2.54-1.87,3.28-2.44c0.74-0.57,2.06-1.51,2.93-2.08 s2.56-1.58,3.74-2.25s3.47-1.72,5.09-2.34c1.62-0.62,4.15-0.78,5.63-0.34c1.48,0.43,3.28,1.2,3.99,1.72 c0.72,0.51,1.83,1.3,2.46,1.75C334.88,215.22,335.32,217.17,335.22,219.09z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M335.22,219.09c-0.1,1.93-1.6,4.56-3.35,5.86s-4.14,3.72-5.32,5.38c-1.18,1.66-2.58,3.62-3.1,4.36 s-2.2,1.13-3.72,0.86s-4.1-0.74-5.74-1.07c-1.64-0.32-3.84-1.06-4.89-1.63c-1.05-0.57-2.7-1.6-3.67-2.29s-1.74-2.19-1.73-3.34 s0.36-2.76,0.75-3.58c0.4-0.82,1.59-2.12,2.66-2.89c1.07-0.77,2.54-1.87,3.28-2.44c0.74-0.57,2.06-1.51,2.93-2.08 s2.56-1.58,3.74-2.25s3.47-1.72,5.09-2.34c1.62-0.62,4.15-0.78,5.63-0.34c1.48,0.43,3.28,1.2,3.99,1.72 c0.72,0.51,1.83,1.3,2.46,1.75C334.88,215.22,335.32,217.17,335.22,219.09z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_146_",
    cx: -128.3531,
    cy: -149.1539,
    r: 4.3419,
    gradientTransform: "matrix(-0.7446 0.7988 -0.7988 -0.7446 104.6525 215.1845)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    style: {
      stopColor: "#B3DAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9166,
    style: {
      stopColor: "#77C1D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#6EBED0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6EBED0"
    }
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    className: "st151",
    cx: 319.37,
    cy: 223.72,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_147_",
    cx: 332.0391,
    cy: 207.9536,
    r: 15.1469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFF0F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    style: {
      stopColor: "#D5ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    style: {
      stopColor: "#BDE0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A6D6E3"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M330.05,200.14c-1.37-1-3.47-1.5-4.67-1.13c-1.2,0.37-3.89,1.9-5.98,3.39c0,0,0,0-0.74,0.75 c-0.74,0.75-0.74,0.75-0.74,0.75c-2.9,0.66-5.28,2.46-5.28,4c0,1.53,0.51,3.54,1.14,4.45c0.63,0.91,2.66,2.03,4.52,2.49 c1.86,0.46,5.27,1.13,7.58,1.51c2.31,0.37,5.71,0.68,7.56,0.68c1.85,0,5.06-1.15,7.13-2.56s4.99-3.21,6.5-4 c1.51-0.79,3.33-2.79,4.06-4.45c0.72-1.66,0.2-3.69-1.17-4.52c-1.37-0.83-4.27-1.54-6.46-1.58c-2.18-0.04-5.54,0.4-7.46,0.98 S331.42,201.13,330.05,200.14z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M330.05,200.14c-1.37-1-3.47-1.5-4.67-1.13c-1.2,0.37-3.89,1.9-5.98,3.39c0,0,0,0-0.74,0.75 c-0.74,0.75-0.74,0.75-0.74,0.75c-2.9,0.66-5.28,2.46-5.28,4c0,1.53,0.51,3.54,1.14,4.45c0.63,0.91,2.66,2.03,4.52,2.49 c1.86,0.46,5.27,1.13,7.58,1.51c2.31,0.37,5.71,0.68,7.56,0.68c1.85,0,5.06-1.15,7.13-2.56s4.99-3.21,6.5-4 c1.51-0.79,3.33-2.79,4.06-4.45c0.72-1.66,0.2-3.69-1.17-4.52c-1.37-0.83-4.27-1.54-6.46-1.58c-2.18-0.04-5.54,0.4-7.46,0.98 S331.42,201.13,330.05,200.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_148_",
    cx: 371.7025,
    cy: 227.6741,
    r: 4.3419,
    gradientTransform: "matrix(-0.7446 0.7988 -0.7988 -0.7446 790.5048 81.2892)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    style: {
      stopColor: "#B3DAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9166,
    style: {
      stopColor: "#77C1D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#6EBED0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6EBED0"
    }
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    className: "st153",
    cx: 331.86,
    cy: 208.67,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_149_",
    cx: 55.7327,
    cy: -393.7417,
    r: 13.3821,
    gradientTransform: "matrix(0.9755 0.2202 -0.2202 0.9755 164.7701 570.5557)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.848288e-7,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FDF8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4452,
    style: {
      stopColor: "#F8EAD6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7937,
    style: {
      stopColor: "#F2D9B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EECE9A"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M296.15,187.66c1.46-1.48,4-2.58,5.65-2.43c1.65,0.15,3.1,1.96,3.23,4.03c0.13,2.07,2.31,5.2,4.84,6.97 c2.54,1.76,5.97,3.51,7.62,3.88s2.43,2.4,1.71,4.5s-2.98,4.72-5.02,5.82c-2.04,1.1-5.77,1.54-8.27,0.97 c-2.51-0.57-5.95-1.34-7.65-1.73c-1.7-0.38-3.79-1.9-4.65-3.37s-1.71-4.41-1.88-6.53c-0.18-2.12,0.15-5.11,0.73-6.64 C293.02,191.61,294.69,189.15,296.15,187.66z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.15,187.66c1.46-1.48,4-2.58,5.65-2.43c1.65,0.15,3.1,1.96,3.23,4.03c0.13,2.07,2.31,5.2,4.84,6.97 c2.54,1.76,5.97,3.51,7.62,3.88s2.43,2.4,1.71,4.5s-2.98,4.72-5.02,5.82c-2.04,1.1-5.77,1.54-8.27,0.97 c-2.51-0.57-5.95-1.34-7.65-1.73c-1.7-0.38-3.79-1.9-4.65-3.37s-1.71-4.41-1.88-6.53c-0.18-2.12,0.15-5.11,0.73-6.64 C293.02,191.61,294.69,189.15,296.15,187.66z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_150_",
    cx: 761.2614,
    cy: -236.5005,
    r: 4.3419,
    gradientTransform: "matrix(0.2518 -1.0626 1.0626 0.2518 363.8835 1068.5073)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 9.590021e-8,
    style: {
      stopColor: "#FBD9BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#F9CDA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6583,
    style: {
      stopColor: "#F3AF77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#EE9850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE9850"
    }
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    className: "st155",
    cx: 304.26,
    cy: 200.03,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_151_",
    cx: 309.8541,
    cy: 129.2417,
    r: 13.7138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.848288e-7,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FDF8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4452,
    style: {
      stopColor: "#F8EAD6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7937,
    style: {
      stopColor: "#F2D9B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EECE9A"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M297.12,137.58c0-1.05,0.25-4.45,0.56-7.56c0.31-3.1,1.88-7.31,3.5-9.36c1.61-2.05,5.32-4.48,8.23-5.41 c2.92-0.93,6.57-0.83,8.12,0.23c1.55,1.05,3.58,3.9,4.51,6.32s0.63,5.87-0.68,7.67c-1.3,1.8-4.3,4.39-6.65,5.75 c-2.36,1.36-4.59,3.5-4.96,4.74c-0.37,1.24-2.2,2.86-4.06,3.61c-1.86,0.74-4.55,0.14-5.98-1.35 C298.29,140.71,297.12,138.63,297.12,137.58z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.12,137.58c0-1.05,0.25-4.45,0.56-7.56c0.31-3.1,1.88-7.31,3.5-9.36c1.61-2.05,5.32-4.48,8.23-5.41 c2.92-0.93,6.57-0.83,8.12,0.23c1.55,1.05,3.58,3.9,4.51,6.32s0.63,5.87-0.68,7.67c-1.3,1.8-4.3,4.39-6.65,5.75 c-2.36,1.36-4.59,3.5-4.96,4.74c-0.37,1.24-2.2,2.86-4.06,3.61c-1.86,0.74-4.55,0.14-5.98-1.35 C298.29,140.71,297.12,138.63,297.12,137.58z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_152_",
    cx: 274.2725,
    cy: 270.179,
    r: 4.3419,
    gradientTransform: "matrix(-0.1546 1.081 -1.081 -0.1546 643.9711 -125.4923)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 9.590021e-8,
    style: {
      stopColor: "#FBD9BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#F9CDA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6583,
    style: {
      stopColor: "#F3AF77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#EE9850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE9850"
    }
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    className: "st157",
    cx: 309.49,
    cy: 129.23,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_153_",
    cx: 221.2273,
    cy: 145.0934,
    r: 13.7071,
    gradientTransform: "matrix(0.3946 0.9188 -0.9188 0.3946 387.8202 -37.3515)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.848288e-7,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FDF8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4452,
    style: {
      stopColor: "#F8EAD6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7937,
    style: {
      stopColor: "#F2D9B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EECE9A"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M356.7,218.69c-0.68,0.93-2.26,2.57-3.51,3.66c-1.25,1.09-2.68,2.74-3.18,3.67 c-0.5,0.93-1.6,2.58-2.44,3.68c-0.84,1.1-3.32,2.8-5.52,3.77c0,0,0,0-0.58,0.19c-0.58,0.19-0.58,0.19-0.58,0.19 c-2.89,0.61-6.24,0.99-7.43,0.84c-1.19-0.15-2.77-0.85-3.5-1.54c-0.73-0.69-1.94-1.91-2.68-2.72s-1.43-1.65-1.53-1.89 c-0.1-0.23,0.71-1.91,1.79-3.73c1.09-1.82,3.26-4.26,4.82-5.44c1.57-1.17,3.81-2.91,4.98-3.87s4.38-2.7,7.12-3.88 c2.74-1.18,6.15-1.67,7.57-1.1c1.42,0.57,3.33,2.26,4.24,3.76C357.2,215.78,357.38,217.77,356.7,218.69z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.7,218.69c-0.68,0.93-2.26,2.57-3.51,3.66c-1.25,1.09-2.68,2.74-3.18,3.67c-0.5,0.93-1.6,2.58-2.44,3.68 c-0.84,1.1-3.32,2.8-5.52,3.77c0,0,0,0-0.58,0.19c-0.58,0.19-0.58,0.19-0.58,0.19c-2.89,0.61-6.24,0.99-7.43,0.84 c-1.19-0.15-2.77-0.85-3.5-1.54c-0.73-0.69-1.94-1.91-2.68-2.72s-1.43-1.65-1.53-1.89c-0.1-0.23,0.71-1.91,1.79-3.73 c1.09-1.82,3.26-4.26,4.82-5.44c1.57-1.17,3.81-2.91,4.98-3.87s4.38-2.7,7.12-3.88c2.74-1.18,6.15-1.67,7.57-1.1 c1.42,0.57,3.33,2.26,4.24,3.76C357.2,215.78,357.38,217.77,356.7,218.69z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_154_",
    cx: 330.3751,
    cy: 199.4127,
    r: 4.3419,
    gradientTransform: "matrix(-0.1546 1.081 -1.081 -0.1546 608.0083 -103.7537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 9.590021e-8,
    style: {
      stopColor: "#FBD9BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#F9CDA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6583,
    style: {
      stopColor: "#F3AF77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#EE9850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE9850"
    }
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    className: "st159",
    cx: 341.35,
    cy: 222.56,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_155_",
    cx: 829.616,
    cy: 584.0804,
    r: 17.5118,
    gradientTransform: "matrix(-0.5558 -0.8313 0.8313 -0.5558 330.9231 1197.6044)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2901,
    style: {
      stopColor: "#EED9E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5881,
    style: {
      stopColor: "#E2BCD3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8336,
    style: {
      stopColor: "#DBABC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D9A4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D9A4C4"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M344.38,196.29c-1.61-1.4-2.63-4.02-2.26-5.83s1.27-4.97,2.02-7.03c0.75-2.06,2.86-5.4,4.7-7.43 c1.84-2.03,4.52-4.09,5.96-4.58c1.44-0.49,4.08-1.35,5.87-1.91c1.79-0.56,3.91-0.43,4.72,0.28c0.81,0.71,2.03,2.53,2.71,4.05 c0.68,1.52,0.37,5.02-0.68,7.79c-1.05,2.77-3.54,5.46-5.52,5.99c-1.98,0.53-5.06,1.93-6.85,3.12c-1.78,1.19-4.25,3.5-5.48,5.12 C348.32,197.5,345.99,197.69,344.38,196.29z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.38,196.29c-1.61-1.4-2.63-4.02-2.26-5.83s1.27-4.97,2.02-7.03c0.75-2.06,2.86-5.4,4.7-7.43 c1.84-2.03,4.52-4.09,5.96-4.58c1.44-0.49,4.08-1.35,5.87-1.91c1.79-0.56,3.91-0.43,4.72,0.28c0.81,0.71,2.03,2.53,2.71,4.05 c0.68,1.52,0.37,5.02-0.68,7.79c-1.05,2.77-3.54,5.46-5.52,5.99c-1.98,0.53-5.06,1.93-6.85,3.12c-1.78,1.19-4.25,3.5-5.48,5.12 C348.32,197.5,345.99,197.69,344.38,196.29z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_156_",
    cx: 569.5454,
    cy: -133.1272,
    r: 4.3419,
    gradientTransform: "matrix(0.6652 0.8661 -0.8663 0.6653 -141.1906 -221.3123)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    className: "st161",
    cx: 352.97,
    cy: 183.4,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_157_",
    cx: 313.5923,
    cy: 191.5821,
    r: 17.9398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2901,
    style: {
      stopColor: "#EED9E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5881,
    style: {
      stopColor: "#E2BCD3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8336,
    style: {
      stopColor: "#DBABC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D9A4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D9A4C4"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M303.13,183.76c0.79-1.76,3.67-3.43,6.41-3.69c2.74-0.27,5.96-0.49,7.15-0.49s2.76,0.85,3.47,1.88 c0.71,1.04,2.35,3,3.64,4.37s3.02,3.13,3.84,3.92c0.82,0.79,1.57,2.27,1.66,3.29s0.09,3.09,0,4.6s-0.46,3.25-0.82,3.87 s-1.43,1.3-2.39,1.5c-0.95,0.21-2.97,0.04-4.48-0.37c-1.51-0.41-3.79-1.09-5.07-1.5c-1.28-0.41-3.14-1.39-4.14-2.17 c-1-0.78-2.53-2.21-3.41-3.17c-0.88-0.97-2.44-2.77-3.47-4.02c-1.03-1.24-2.31-2.84-2.85-3.54 C302.14,187.55,302.34,185.53,303.13,183.76z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.13,183.76c0.79-1.76,3.67-3.43,6.41-3.69c2.74-0.27,5.96-0.49,7.15-0.49s2.76,0.85,3.47,1.88 c0.71,1.04,2.35,3,3.64,4.37s3.02,3.13,3.84,3.92c0.82,0.79,1.57,2.27,1.66,3.29s0.09,3.09,0,4.6s-0.46,3.25-0.82,3.87 s-1.43,1.3-2.39,1.5c-0.95,0.21-2.97,0.04-4.48-0.37c-1.51-0.41-3.79-1.09-5.07-1.5c-1.28-0.41-3.14-1.39-4.14-2.17 c-1-0.78-2.53-2.21-3.41-3.17c-0.88-0.97-2.44-2.77-3.47-4.02c-1.03-1.24-2.31-2.84-2.85-3.54 C302.14,187.55,302.34,185.53,303.13,183.76z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_158_",
    cx: 37.2634,
    cy: 128.7578,
    r: 4.3419,
    gradientTransform: "matrix(-1.0897 0.0716 -0.0716 -1.0899 364.0468 328.8584)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    className: "st163",
    cx: 314.22,
    cy: 191.2,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_159_",
    gradientUnits: "userSpaceOnUse",
    x1: 776.2309,
    y1: 614.5314,
    x2: 847.0016,
    y2: 614.5314,
    gradientTransform: "matrix(0.1743 -0.8557 -0.584 -0.119 553.3984 954.2191)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A2576F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4658,
    style: {
      stopColor: "#A25970"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6336,
    style: {
      stopColor: "#A55E73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7531,
    style: {
      stopColor: "#A9677A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8498,
    style: {
      stopColor: "#B07383"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    style: {
      stopColor: "#B98491"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C69AA4"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M307.27,210.9c0,0,1.79-1.5,3.97-3.33c2.19-1.83,5.51-4.9,7.38-6.82c1.88-1.92,4.68-6.19,6.22-9.51 c1.55-3.31,4.17-8.3,5.83-11.08c1.66-2.78,5.47-7.1,8.46-9.6s8.55-5.59,12.35-6.87c3.8-1.28,8.47-2,10.39-1.61 c1.92,0.39,3.48,0.71,3.48,0.71"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_160_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.3495,
    y1: 208.1352,
    x2: 322.2819,
    y2: 208.1352,
    gradientTransform: "matrix(1.3333 0.4315 -0.526 1.6253 51.7971 -239.6202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A2576F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2911,
    style: {
      stopColor: "#A35970"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4913,
    style: {
      stopColor: "#A66075"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6642,
    style: {
      stopColor: "#AC6C7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8216,
    style: {
      stopColor: "#B57C8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9672,
    style: {
      stopColor: "#C2939E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C69AA4"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M272.44,238.3c0,0,5.29-3.67,11.76-8.15c6.47-4.48,15.31-11.72,19.66-16.09 c4.34-4.37,10.68-9.07,14.09-10.45c3.4-1.38,10.35-2.53,15.44-2.56c5.09-0.03,14,1.06,19.81,2.44c5.81,1.37,14.43,3.16,19.17,3.98 c4.74,0.82,8.61,1.48,8.61,1.48"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_161_",
    cx: 177.6215,
    cy: 511.3808,
    r: 16.2529,
    gradientTransform: "matrix(-0.3526 0.9358 -0.9358 -0.3526 919.486 219.5231)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CACFE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2831,
    style: {
      stopColor: "#C6CCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5169,
    style: {
      stopColor: "#BBC2DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7331,
    style: {
      stopColor: "#A9B3D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    style: {
      stopColor: "#919FC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8998C1"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M389.18,199.18c0.2,0.64-0.08,2.92-0.61,5.05c-0.54,2.13-1.64,5.35-2.45,7.14 c-0.81,1.8-2.12,4.69-2.9,6.43c-0.79,1.74-2.4,3.4-3.58,3.7s-3.03,0.49-4.11,0.44c-1.08-0.06-2.72-1.28-3.64-2.72 s-2.49-3.03-3.5-3.54c-1-0.51-2-1.71-2.21-2.68c-0.21-0.96,0.63-2.42,1.87-3.24c1.24-0.82,2.14-2.34,1.99-3.37 s-0.19-2.55-0.1-3.37c0.09-0.82,0.47-2.31,0.84-3.31c0.37-1,1.13-2.14,1.68-2.55s2.65-1.06,4.66-1.46 c2.01-0.39,4.7-0.69,5.97-0.66s3.08,0.71,4.02,1.51C388.05,197.36,388.98,198.54,389.18,199.18z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M389.18,199.18c0.2,0.64-0.08,2.92-0.61,5.05c-0.54,2.13-1.64,5.35-2.45,7.14c-0.81,1.8-2.12,4.69-2.9,6.43 c-0.79,1.74-2.4,3.4-3.58,3.7s-3.03,0.49-4.11,0.44c-1.08-0.06-2.72-1.28-3.64-2.72s-2.49-3.03-3.5-3.54 c-1-0.51-2-1.71-2.21-2.68c-0.21-0.96,0.63-2.42,1.87-3.24c1.24-0.82,2.14-2.34,1.99-3.37s-0.19-2.55-0.1-3.37 c0.09-0.82,0.47-2.31,0.84-3.31c0.37-1,1.13-2.14,1.68-2.55s2.65-1.06,4.66-1.46c2.01-0.39,4.7-0.69,5.97-0.66 s3.08,0.71,4.02,1.51C388.05,197.36,388.98,198.54,389.18,199.18z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_162_",
    cx: 264.9624,
    cy: 378.2462,
    r: 4.3419,
    gradientTransform: "matrix(0.4297 -1.004 1.0041 0.4298 -115.1024 308.1486)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8998C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D5F99"
    }
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    className: "st167",
    cx: 378.56,
    cy: 204.7,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_163_",
    cx: 369.3246,
    cy: 165.4458,
    r: 14.3745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#887EB3"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M361.12,151.4c-0.08,0.23-0.69,1.6-1.36,3.05c-0.66,1.45-1.07,3.69-0.9,4.98 c0.17,1.29,1.12,3.83,2.11,5.65c1,1.82,1.81,4.88,1.81,6.78s0,4.89,0,6.63c0,1.74,1.29,3.51,2.86,3.92 c1.58,0.41,3.92,0.55,5.2,0.3s2.88-1.98,3.54-3.84c0.66-1.87,1.38-4.95,1.58-6.86s0.92-5.13,1.58-7.16 c0.66-2.03,1.58-5.05,2.04-6.71s0.25-3.95-0.45-5.09c-0.7-1.14-2.54-2.6-4.07-3.24s-4.11-1.41-5.73-1.7s-4.09,0.24-5.5,1.17 S361.2,151.18,361.12,151.4z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.12,151.4c-0.08,0.23-0.69,1.6-1.36,3.05c-0.66,1.45-1.07,3.69-0.9,4.98c0.17,1.29,1.12,3.83,2.11,5.65 c1,1.82,1.81,4.88,1.81,6.78s0,4.89,0,6.63c0,1.74,1.29,3.51,2.86,3.92c1.58,0.41,3.92,0.55,5.2,0.3s2.88-1.98,3.54-3.84 c0.66-1.87,1.38-4.95,1.58-6.86s0.92-5.13,1.58-7.16c0.66-2.03,1.58-5.05,2.04-6.71s0.25-3.95-0.45-5.09 c-0.7-1.14-2.54-2.6-4.07-3.24s-4.11-1.41-5.73-1.7s-4.09,0.24-5.5,1.17S361.2,151.18,361.12,151.4z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_164_",
    cx: 423.9341,
    cy: 241.1654,
    r: 4.3419,
    gradientTransform: "matrix(0.4652 -0.988 0.988 0.4652 -66.0011 469.9998)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3ECF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#887EB3"
    }
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    className: "st169",
    cx: 369.49,
    cy: 163.34,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_165_",
    cx: 409.1738,
    cy: -121.4494,
    r: 17.1122,
    fx: 398.9242,
    fy: -107.7465,
    gradientTransform: "matrix(0.3375 -0.9413 0.9413 0.3375 358.9944 605.8922)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CACFE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2831,
    style: {
      stopColor: "#C6CCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5169,
    style: {
      stopColor: "#BBC2DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7331,
    style: {
      stopColor: "#A9B3D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    style: {
      stopColor: "#919FC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8998C1"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M378.76,194.2c-0.92-1.61-2.74-3.96-4.05-5.23c-1.31-1.27-2.79-3.06-3.3-3.98 c-0.51-0.92,0.14-3.64,1.44-6.04c1.3-2.4,2.53-5.83,2.74-7.63s1.07-4.62,1.93-6.28c0.86-1.65,2.65-2.94,3.97-2.86 c1.33,0.08,3.32,1.07,4.42,2.2s2.12,4.33,2.27,7.1c0.15,2.77,0.79,6.22,1.42,7.66c0.63,1.44,1.16,3.77,1.18,5.19 c0.02,1.42-0.49,4.05-1.13,5.84c-0.64,1.8-1.87,3.92-2.73,4.72c-0.86,0.8-2.67,1.63-4.02,1.84S379.68,195.81,378.76,194.2z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M378.76,194.2c-0.92-1.61-2.74-3.96-4.05-5.23c-1.31-1.27-2.79-3.06-3.3-3.98 c-0.51-0.92,0.14-3.64,1.44-6.04c1.3-2.4,2.53-5.83,2.74-7.63s1.07-4.62,1.93-6.28c0.86-1.65,2.65-2.94,3.97-2.86 c1.33,0.08,3.32,1.07,4.42,2.2s2.12,4.33,2.27,7.1c0.15,2.77,0.79,6.22,1.42,7.66c0.63,1.44,1.16,3.77,1.18,5.19 c0.02,1.42-0.49,4.05-1.13,5.84c-0.64,1.8-1.87,3.92-2.73,4.72c-0.86,0.8-2.67,1.63-4.02,1.84S379.68,195.81,378.76,194.2z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_166_",
    cx: 675.2297,
    cy: 161.6208,
    r: 4.3419,
    gradientTransform: "matrix(1.0117 -0.4112 0.4113 1.0118 -367.7387 295.011)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8998C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D5F99"
    }
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    className: "st171",
    cx: 381.84,
    cy: 180.87,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_167_",
    cx: 340.5139,
    cy: 163.8217,
    r: 13.7029,
    gradientTransform: "matrix(0.8982 -0.4395 0.4395 0.8982 -85.8405 181.7209)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.848288e-7,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#FDF8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4452,
    style: {
      stopColor: "#F8EAD6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7937,
    style: {
      stopColor: "#F2D9B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EECE9A"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st172",
    d: "M280.42,186.36c0.33-0.94,2.15-3.38,4.06-5.43c1.91-2.05,3.63-5.08,3.83-6.75 c0.2-1.67,0.36-4.12,0.35-5.46c-0.01-1.34,1.36-3.1,3.03-3.92c1.68-0.82,4.04-0.85,5.26-0.06s3.41,2.5,4.88,3.8 c1.47,1.3,3.5,4.85,4.53,7.88c0,0,0,0-0.07,0.2c-0.07,0.2-0.51,4.78-0.85,5.12c-0.34,0.33-0.34,0.33-0.34,0.33 c-1.84,2.85-4.06,6.09-4.95,7.21c-0.88,1.12-2.65,1.98-3.93,1.92c-1.28-0.06-3.72-0.11-5.43-0.11s-4.06,0.2-5.22,0.45 s-2.93-0.44-3.93-1.52S280.09,187.29,280.42,186.36z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.42,186.36c0.33-0.94,2.15-3.38,4.06-5.43c1.91-2.05,3.63-5.08,3.83-6.75c0.2-1.67,0.36-4.12,0.35-5.46 c-0.01-1.34,1.36-3.1,3.03-3.92c1.68-0.82,4.04-0.85,5.26-0.06s3.41,2.5,4.88,3.8c1.47,1.3,3.5,4.85,4.53,7.88c0,0,0,0-0.07,0.2 c-0.07,0.2-0.51,4.78-0.85,5.12c-0.34,0.33-0.34,0.33-0.34,0.33c-1.84,2.85-4.06,6.09-4.95,7.21c-0.88,1.12-2.65,1.98-3.93,1.92 c-1.28-0.06-3.72-0.11-5.43-0.11s-4.06,0.2-5.22,0.45s-2.93-0.44-3.93-1.52S280.09,187.29,280.42,186.36z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_168_",
    cx: 285.7234,
    cy: 227.9339,
    r: 4.3419,
    gradientTransform: "matrix(0.3363 1.039 -1.039 0.3363 434.063 -193.9562)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 9.590021e-8,
    style: {
      stopColor: "#FBD9BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#F9CDA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6583,
    style: {
      stopColor: "#F3AF77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#EE9850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE9850"
    }
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    className: "st173",
    cx: 293.32,
    cy: 179.55,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_169_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.1784,
    y1: 261.1184,
    x2: 292.1784,
    y2: 185.1921,
    gradientTransform: "matrix(1.4012 0.5446 -0.3552 0.9138 -33.0391 -180.1553)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A2576F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2955,
    style: {
      stopColor: "#A35970"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4949,
    style: {
      stopColor: "#A66075"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    style: {
      stopColor: "#AC6B7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8212,
    style: {
      stopColor: "#B57B8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9642,
    style: {
      stopColor: "#C1929D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C69AA4"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st174",
    d: "M296.29,221.08c0,0-2.2-3.26-4.9-7.25s-4.83-12.33-4.75-18.54s0.97-16.57,1.98-23.02 c1.01-6.45,5.78-14.55,10.6-17.99c4.82-3.44,8.76-6.25,8.76-6.25"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_170_",
    cx: 416.1433,
    cy: 358.4992,
    r: 12.8596,
    gradientTransform: "matrix(-0.7387 -0.674 0.674 -0.7387 359.4188 706.5867)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFF0F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    style: {
      stopColor: "#D5ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    style: {
      stopColor: "#BDE0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A6D6E3"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "M285.45,174.84c-1.73-1.3-2.88-3.77-2.55-5.49c0.33-1.71,0.85-4.55,1.15-6.29 c0.3-1.75,0.79-4.19,1.09-5.44c0.3-1.25,1.43-2.79,2.51-3.42s3.27-1.82,4.84-2.62c1.58-0.81,4.38-1.97,6.23-2.58 c1.85-0.61,4.04-0.5,4.87,0.26c0.83,0.75,2.25,2.47,3.16,3.8s1.02,3.55,0.25,4.92s-3.35,4.62-5.73,7.22 c-2.38,2.6-4.76,5.8-5.3,7.1c-0.54,1.3-2.42,2.94-4.18,3.64C290.04,176.64,287.18,176.14,285.45,174.84z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M285.45,174.84c-1.73-1.3-2.88-3.77-2.55-5.49c0.33-1.71,0.85-4.55,1.15-6.29 c0.3-1.75,0.79-4.19,1.09-5.44c0.3-1.25,1.43-2.79,2.51-3.42s3.27-1.82,4.84-2.62c1.58-0.81,4.38-1.97,6.23-2.58 c1.85-0.61,4.04-0.5,4.87,0.26c0.83,0.75,2.25,2.47,3.16,3.8s1.02,3.55,0.25,4.92s-3.35,4.62-5.73,7.22 c-2.38,2.6-4.76,5.8-5.3,7.1c-0.54,1.3-2.42,2.94-4.18,3.64C290.04,176.64,287.18,176.14,285.45,174.84z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_171_",
    cx: 280.6542,
    cy: 355.5467,
    r: 4.3419,
    gradientTransform: "matrix(-0.7446 0.7988 -0.7988 -0.7446 786.6136 202.3215)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    style: {
      stopColor: "#B3DAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9166,
    style: {
      stopColor: "#77C1D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#6EBED0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6EBED0"
    }
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    className: "st176",
    cx: 293.62,
    cy: 161.76,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_172_",
    cx: 458.5905,
    cy: 465.9609,
    r: 15.9362,
    gradientTransform: "matrix(-0.655 -0.7556 0.7556 -0.655 259.8998 800.0144)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CACFE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2831,
    style: {
      stopColor: "#C6CCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5169,
    style: {
      stopColor: "#BBC2DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7331,
    style: {
      stopColor: "#A9B3D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    style: {
      stopColor: "#919FC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8998C1"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st177",
    d: "M314.93,156.36c0.48-0.2,1.65-1.03,2.59-1.85s2.69-2.01,3.89-2.65c1.2-0.64,2.97-2.18,3.93-3.41 c0.96-1.23,1.26-2.8,0.67-3.49s-1.91-2.2-2.91-3.36c-1-1.16-3.01-2.56-4.45-3.12s-4.05-1-5.78-0.97 c-1.74,0.02-4.98,0.5-7.21,1.06c-2.23,0.56-5.31,2.11-6.85,3.44c-1.54,1.33-2.77,4.1-2.74,6.16c0.03,2.06,0.93,4.34,1.99,5.06 c1.07,0.72,2.72,0.98,3.68,0.56s2.62-0.78,3.68-0.82c1.07-0.04,2.63,0.37,3.48,0.91c0.85,0.54,2.36,1.39,3.35,1.91 S314.45,156.56,314.93,156.36z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M314.93,156.36c0.48-0.2,1.65-1.03,2.59-1.85s2.69-2.01,3.89-2.65c1.2-0.64,2.97-2.18,3.93-3.41 c0.96-1.23,1.26-2.8,0.67-3.49s-1.91-2.2-2.91-3.36c-1-1.16-3.01-2.56-4.45-3.12s-4.05-1-5.78-0.97 c-1.74,0.02-4.98,0.5-7.21,1.06c-2.23,0.56-5.31,2.11-6.85,3.44c-1.54,1.33-2.77,4.1-2.74,6.16c0.03,2.06,0.93,4.34,1.99,5.06 c1.07,0.72,2.72,0.98,3.68,0.56s2.62-0.78,3.68-0.82c1.07-0.04,2.63,0.37,3.48,0.91c0.85,0.54,2.36,1.39,3.35,1.91 S314.45,156.56,314.93,156.36z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_173_",
    cx: 316.2689,
    cy: 121.7305,
    r: 4.3419,
    gradientTransform: "matrix(0.6782 0.8559 -0.8561 0.6783 201.3226 -205.4034)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8998C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D5F99"
    }
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    className: "st178",
    cx: 311.6,
    cy: 147.87,
    r: 4.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_174_",
    cx: 388.9753,
    cy: 693.6089,
    r: 15.9362,
    gradientTransform: "matrix(-0.4728 -0.8812 0.8812 -0.4728 -100.925 806.8342)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CACFE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2831,
    style: {
      stopColor: "#C6CCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5169,
    style: {
      stopColor: "#BBC2DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7331,
    style: {
      stopColor: "#A9B3D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    style: {
      stopColor: "#919FC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8998C1"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M327.81,144.75c0.52-0.09,1.84-0.64,2.93-1.23c1.1-0.59,3.07-1.37,4.38-1.73 c1.31-0.36,3.37-1.47,4.58-2.46c1.21-0.99,1.85-2.46,1.42-3.26c-0.43-0.8-1.38-2.57-2.1-3.92c-0.73-1.35-2.37-3.16-3.66-4.03 s-3.73-1.86-5.43-2.22c-1.7-0.36-4.97-0.61-7.27-0.55c-2.3,0.06-5.64,0.89-7.43,1.85c-1.79,0.96-3.6,3.4-4.03,5.41 c-0.42,2.02-0.05,4.43,0.83,5.37c0.88,0.94,2.44,1.55,3.47,1.36c1.03-0.19,2.72-0.19,3.77,0.01c1.05,0.2,2.49,0.94,3.2,1.65 c0.71,0.71,1.99,1.88,2.85,2.6C326.17,144.32,327.29,144.83,327.81,144.75z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M327.81,144.75c0.52-0.09,1.84-0.64,2.93-1.23c1.1-0.59,3.07-1.37,4.38-1.73 c1.31-0.36,3.37-1.47,4.58-2.46c1.21-0.99,1.85-2.46,1.42-3.26c-0.43-0.8-1.38-2.57-2.1-3.92c-0.73-1.35-2.37-3.16-3.66-4.03 s-3.73-1.86-5.43-2.22c-1.7-0.36-4.97-0.61-7.27-0.55c-2.3,0.06-5.64,0.89-7.43,1.85c-1.79,0.96-3.6,3.4-4.03,5.41 c-0.42,2.02-0.05,4.43,0.83,5.37c0.88,0.94,2.44,1.55,3.47,1.36c1.03-0.19,2.72-0.19,3.77,0.01c1.05,0.2,2.49,0.94,3.2,1.65 c0.71,0.71,1.99,1.88,2.85,2.6C326.17,144.32,327.29,144.83,327.81,144.75z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_175_",
    cx: 489.404,
    cy: 254.184,
    r: 4.3419,
    gradientTransform: "matrix(0.4734 0.9841 -0.9843 0.4735 344.9423 -466.2414)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8998C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D5F99"
    }
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    className: "st180",
    cx: 326.43,
    cy: 135.73,
    r: 4.74
  })))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 510.2312 120.8817)",
    className: "st90 st91"
  }, "B cells")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_176_",
    cx: 490.4792,
    cy: 112.1081,
    r: 10.8196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFF0F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    style: {
      stopColor: "#D5ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    style: {
      stopColor: "#BDE0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A6D6E3"
    }
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    className: "st181",
    cx: 490.48,
    cy: 112.11,
    r: 10.82
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_177_",
    cx: 492.5257,
    cy: 112.2483,
    r: 7.2152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    style: {
      stopColor: "#B3DAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9166,
    style: {
      stopColor: "#77C1D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#6EBED0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6EBED0"
    }
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    className: "st182",
    cx: 492.53,
    cy: 112.25,
    r: 7.22
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_178_",
    cx: 475.2236,
    cy: 130.7684,
    r: 10.8196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFF0F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    style: {
      stopColor: "#D5ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    style: {
      stopColor: "#BDE0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A6D6E3"
    }
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    className: "st183",
    cx: 475.22,
    cy: 130.77,
    r: 10.82
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_179_",
    cx: 477.2702,
    cy: 130.9085,
    r: 7.2152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    style: {
      stopColor: "#B3DAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9166,
    style: {
      stopColor: "#77C1D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#6EBED0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6EBED0"
    }
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    className: "st184",
    cx: 477.27,
    cy: 130.91,
    r: 7.22
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_180_",
    cx: 406.3875,
    cy: 525.3598,
    r: 2.5512,
    gradientTransform: "matrix(-0.45 -0.893 0.893 -0.45 158.3867 737.0253)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    className: "st185",
    cx: 444.64,
    cy: 137.68,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_181_",
    cx: 397.8093,
    cy: 518.0237,
    r: 2.5512,
    gradientTransform: "matrix(-0.45 -0.893 0.893 -0.45 158.3867 737.0253)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    className: "st186",
    cx: 441.95,
    cy: 148.64,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_182_",
    cx: 394.3335,
    cy: 527.7423,
    r: 2.5512,
    gradientTransform: "matrix(-0.45 -0.893 0.893 -0.45 158.3867 737.0253)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    className: "st187",
    cx: 452.19,
    cy: 147.37,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_183_",
    cx: 399.656,
    cy: 504.2517,
    r: 2.5512,
    gradientTransform: "matrix(-0.45 -0.893 0.893 -0.45 158.3867 737.0253)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    className: "st188",
    cx: 428.82,
    cy: 153.19,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_184_",
    cx: 404.5135,
    cy: 494.6131,
    r: 2.5512,
    gradientTransform: "matrix(-0.45 -0.893 0.893 -0.45 158.3867 737.0253)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    className: "st189",
    cx: 418.03,
    cy: 153.19,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_185_",
    cx: 389.5659,
    cy: 521.0425,
    r: 2.5512,
    gradientTransform: "matrix(-0.45 -0.893 0.893 -0.45 158.3867 737.0253)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    className: "st190",
    cx: 448.36,
    cy: 154.65,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_186_",
    cx: 408.6192,
    cy: 514.0594,
    r: 2.5512,
    gradientTransform: "matrix(-0.45 -0.893 0.893 -0.45 158.3867 737.0253)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    className: "st191",
    cx: 433.55,
    cy: 140.77,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_187_",
    cx: 402.5925,
    cy: 531.4818,
    r: 2.5512,
    gradientTransform: "matrix(-0.45 -0.893 0.893 -0.45 158.3867 737.0253)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    className: "st192",
    cx: 451.82,
    cy: 138.32,
    r: 2.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_188_",
    cx: 391.4577,
    cy: 539.1184,
    r: 2.5512,
    gradientTransform: "matrix(-0.45 -0.893 0.893 -0.45 158.3867 737.0253)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#E8CBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2035,
    style: {
      stopColor: "#DBA9C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D28EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#CB7BAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6646,
    style: {
      stopColor: "#C76DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#C4649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3619B"
    }
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    className: "st193",
    cx: 463.65,
    cy: 144.82,
    r: 2.55
  }))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 304.3934 102.9713)",
    className: "st90 st91"
  }, "Malignant cells")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_189_",
    cx: 499.2357,
    cy: 135.2338,
    r: 10.8196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFF0F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    style: {
      stopColor: "#D5ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    style: {
      stopColor: "#BDE0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A6D6E3"
    }
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    className: "st194",
    cx: 499.24,
    cy: 135.23,
    r: 10.82
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_190_",
    cx: 501.2822,
    cy: 135.3739,
    r: 7.2152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9E5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2973,
    style: {
      stopColor: "#B3DAE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9166,
    style: {
      stopColor: "#77C1D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#6EBED0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6EBED0"
    }
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    className: "st195",
    cx: 501.28,
    cy: 135.37,
    r: 7.22
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.45b6e767ce0f8cfed8e4da9193bbe015.svg";
export { ForwardRef as ReactComponent };